import React, { createContext, useContext, useMemo, Fragment, useState, useEffect, forwardRef, createElement, useCallback, useRef } from 'react';
import { Button, ButtonText } from '@andes/button';
import { Phrase } from '@polycard/phrase';
import classnames from 'classnames';
import ProgressIndicatorLinear from '@andes/progress-indicator-linear';
import Image from 'frontend-image';
import CheckboxAndes from '@andes/checkbox';
import CardUI from '@andes/card';
import Tag from '@andes/tag';
import { InputStepper } from '@andes/input-stepper';
import { MoneyAmount, MoneyAmountDiscount } from '@andes/money-amount';
import { DropdownStandalone } from '@andes/dropdown';
import { ListItem } from '@andes/list';

var jsxRuntime = {exports: {}};

var reactJsxRuntime_production_min = {};

/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactJsxRuntime_production_min;

function requireReactJsxRuntime_production_min () {
	if (hasRequiredReactJsxRuntime_production_min) return reactJsxRuntime_production_min;
	hasRequiredReactJsxRuntime_production_min = 1;
var f=React,k=Symbol.for("react.element"),l=Symbol.for("react.fragment"),m=Object.prototype.hasOwnProperty,n=f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,p={key:true,ref:true,__self:true,__source:true};
	function q(c,a,g){var b,d={},e=null,h=null;void 0!==g&&(e=""+g);void 0!==a.key&&(e=""+a.key);void 0!==a.ref&&(h=a.ref);for(b in a)m.call(a,b)&&!p.hasOwnProperty(b)&&(d[b]=a[b]);if(c&&c.defaultProps)for(b in a=c.defaultProps,a) void 0===d[b]&&(d[b]=a[b]);return {$$typeof:k,type:c,key:e,ref:h,props:d,_owner:n.current}}reactJsxRuntime_production_min.Fragment=l;reactJsxRuntime_production_min.jsx=q;reactJsxRuntime_production_min.jsxs=q;
	return reactJsxRuntime_production_min;
}

var reactJsxRuntime_development = {};

/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactJsxRuntime_development;

function requireReactJsxRuntime_development () {
	if (hasRequiredReactJsxRuntime_development) return reactJsxRuntime_development;
	hasRequiredReactJsxRuntime_development = 1;

	if (process.env.NODE_ENV !== "production") {
	  (function() {

	var React$1 = React;

	// ATTENTION
	// When adding new symbols to this file,
	// Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
	// The Symbol used to tag the ReactElement-like types.
	var REACT_ELEMENT_TYPE = Symbol.for('react.element');
	var REACT_PORTAL_TYPE = Symbol.for('react.portal');
	var REACT_FRAGMENT_TYPE = Symbol.for('react.fragment');
	var REACT_STRICT_MODE_TYPE = Symbol.for('react.strict_mode');
	var REACT_PROFILER_TYPE = Symbol.for('react.profiler');
	var REACT_PROVIDER_TYPE = Symbol.for('react.provider');
	var REACT_CONTEXT_TYPE = Symbol.for('react.context');
	var REACT_FORWARD_REF_TYPE = Symbol.for('react.forward_ref');
	var REACT_SUSPENSE_TYPE = Symbol.for('react.suspense');
	var REACT_SUSPENSE_LIST_TYPE = Symbol.for('react.suspense_list');
	var REACT_MEMO_TYPE = Symbol.for('react.memo');
	var REACT_LAZY_TYPE = Symbol.for('react.lazy');
	var REACT_OFFSCREEN_TYPE = Symbol.for('react.offscreen');
	var MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator';
	function getIteratorFn(maybeIterable) {
	  if (maybeIterable === null || typeof maybeIterable !== 'object') {
	    return null;
	  }

	  var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];

	  if (typeof maybeIterator === 'function') {
	    return maybeIterator;
	  }

	  return null;
	}

	var ReactSharedInternals = React$1.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;

	function error(format) {
	  {
	    {
	      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	        args[_key2 - 1] = arguments[_key2];
	      }

	      printWarning('error', format, args);
	    }
	  }
	}

	function printWarning(level, format, args) {
	  // When changing this logic, you might want to also
	  // update consoleWithStackDev.www.js as well.
	  {
	    var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
	    var stack = ReactDebugCurrentFrame.getStackAddendum();

	    if (stack !== '') {
	      format += '%s';
	      args = args.concat([stack]);
	    } // eslint-disable-next-line react-internal/safe-string-coercion


	    var argsWithFormat = args.map(function (item) {
	      return String(item);
	    }); // Careful: RN currently depends on this prefix

	    argsWithFormat.unshift('Warning: ' + format); // We intentionally don't use spread (or .apply) directly because it
	    // breaks IE9: https://github.com/facebook/react/issues/13610
	    // eslint-disable-next-line react-internal/no-production-logging

	    Function.prototype.apply.call(console[level], console, argsWithFormat);
	  }
	}

	// -----------------------------------------------------------------------------

	var enableScopeAPI = false; // Experimental Create Event Handle API.
	var enableCacheElement = false;
	var enableTransitionTracing = false; // No known bugs, but needs performance testing

	var enableLegacyHidden = false; // Enables unstable_avoidThisFallback feature in Fiber
	// stuff. Intended to enable React core members to more easily debug scheduling
	// issues in DEV builds.

	var enableDebugTracing = false; // Track which Fiber(s) schedule render work.

	var REACT_MODULE_REFERENCE;

	{
	  REACT_MODULE_REFERENCE = Symbol.for('react.module.reference');
	}

	function isValidElementType(type) {
	  if (typeof type === 'string' || typeof type === 'function') {
	    return true;
	  } // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).


	  if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || enableDebugTracing  || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || enableLegacyHidden  || type === REACT_OFFSCREEN_TYPE || enableScopeAPI  || enableCacheElement  || enableTransitionTracing ) {
	    return true;
	  }

	  if (typeof type === 'object' && type !== null) {
	    if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || // This needs to include all possible module reference object
	    // types supported by any Flight configuration anywhere since
	    // we don't know which Flight build this will end up being used
	    // with.
	    type.$$typeof === REACT_MODULE_REFERENCE || type.getModuleId !== undefined) {
	      return true;
	    }
	  }

	  return false;
	}

	function getWrappedName(outerType, innerType, wrapperName) {
	  var displayName = outerType.displayName;

	  if (displayName) {
	    return displayName;
	  }

	  var functionName = innerType.displayName || innerType.name || '';
	  return functionName !== '' ? wrapperName + "(" + functionName + ")" : wrapperName;
	} // Keep in sync with react-reconciler/getComponentNameFromFiber


	function getContextName(type) {
	  return type.displayName || 'Context';
	} // Note that the reconciler package should generally prefer to use getComponentNameFromFiber() instead.


	function getComponentNameFromType(type) {
	  if (type == null) {
	    // Host root, text node or just invalid type.
	    return null;
	  }

	  {
	    if (typeof type.tag === 'number') {
	      error('Received an unexpected object in getComponentNameFromType(). ' + 'This is likely a bug in React. Please file an issue.');
	    }
	  }

	  if (typeof type === 'function') {
	    return type.displayName || type.name || null;
	  }

	  if (typeof type === 'string') {
	    return type;
	  }

	  switch (type) {
	    case REACT_FRAGMENT_TYPE:
	      return 'Fragment';

	    case REACT_PORTAL_TYPE:
	      return 'Portal';

	    case REACT_PROFILER_TYPE:
	      return 'Profiler';

	    case REACT_STRICT_MODE_TYPE:
	      return 'StrictMode';

	    case REACT_SUSPENSE_TYPE:
	      return 'Suspense';

	    case REACT_SUSPENSE_LIST_TYPE:
	      return 'SuspenseList';

	  }

	  if (typeof type === 'object') {
	    switch (type.$$typeof) {
	      case REACT_CONTEXT_TYPE:
	        var context = type;
	        return getContextName(context) + '.Consumer';

	      case REACT_PROVIDER_TYPE:
	        var provider = type;
	        return getContextName(provider._context) + '.Provider';

	      case REACT_FORWARD_REF_TYPE:
	        return getWrappedName(type, type.render, 'ForwardRef');

	      case REACT_MEMO_TYPE:
	        var outerName = type.displayName || null;

	        if (outerName !== null) {
	          return outerName;
	        }

	        return getComponentNameFromType(type.type) || 'Memo';

	      case REACT_LAZY_TYPE:
	        {
	          var lazyComponent = type;
	          var payload = lazyComponent._payload;
	          var init = lazyComponent._init;

	          try {
	            return getComponentNameFromType(init(payload));
	          } catch (x) {
	            return null;
	          }
	        }

	      // eslint-disable-next-line no-fallthrough
	    }
	  }

	  return null;
	}

	var assign = Object.assign;

	// Helpers to patch console.logs to avoid logging during side-effect free
	// replaying on render function. This currently only patches the object
	// lazily which won't cover if the log function was extracted eagerly.
	// We could also eagerly patch the method.
	var disabledDepth = 0;
	var prevLog;
	var prevInfo;
	var prevWarn;
	var prevError;
	var prevGroup;
	var prevGroupCollapsed;
	var prevGroupEnd;

	function disabledLog() {}

	disabledLog.__reactDisabledLog = true;
	function disableLogs() {
	  {
	    if (disabledDepth === 0) {
	      /* eslint-disable react-internal/no-production-logging */
	      prevLog = console.log;
	      prevInfo = console.info;
	      prevWarn = console.warn;
	      prevError = console.error;
	      prevGroup = console.group;
	      prevGroupCollapsed = console.groupCollapsed;
	      prevGroupEnd = console.groupEnd; // https://github.com/facebook/react/issues/19099

	      var props = {
	        configurable: true,
	        enumerable: true,
	        value: disabledLog,
	        writable: true
	      }; // $FlowFixMe Flow thinks console is immutable.

	      Object.defineProperties(console, {
	        info: props,
	        log: props,
	        warn: props,
	        error: props,
	        group: props,
	        groupCollapsed: props,
	        groupEnd: props
	      });
	      /* eslint-enable react-internal/no-production-logging */
	    }

	    disabledDepth++;
	  }
	}
	function reenableLogs() {
	  {
	    disabledDepth--;

	    if (disabledDepth === 0) {
	      /* eslint-disable react-internal/no-production-logging */
	      var props = {
	        configurable: true,
	        enumerable: true,
	        writable: true
	      }; // $FlowFixMe Flow thinks console is immutable.

	      Object.defineProperties(console, {
	        log: assign({}, props, {
	          value: prevLog
	        }),
	        info: assign({}, props, {
	          value: prevInfo
	        }),
	        warn: assign({}, props, {
	          value: prevWarn
	        }),
	        error: assign({}, props, {
	          value: prevError
	        }),
	        group: assign({}, props, {
	          value: prevGroup
	        }),
	        groupCollapsed: assign({}, props, {
	          value: prevGroupCollapsed
	        }),
	        groupEnd: assign({}, props, {
	          value: prevGroupEnd
	        })
	      });
	      /* eslint-enable react-internal/no-production-logging */
	    }

	    if (disabledDepth < 0) {
	      error('disabledDepth fell below zero. ' + 'This is a bug in React. Please file an issue.');
	    }
	  }
	}

	var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
	var prefix;
	function describeBuiltInComponentFrame(name, source, ownerFn) {
	  {
	    if (prefix === undefined) {
	      // Extract the VM specific prefix used by each line.
	      try {
	        throw Error();
	      } catch (x) {
	        var match = x.stack.trim().match(/\n( *(at )?)/);
	        prefix = match && match[1] || '';
	      }
	    } // We use the prefix to ensure our stacks line up with native stack frames.


	    return '\n' + prefix + name;
	  }
	}
	var reentry = false;
	var componentFrameCache;

	{
	  var PossiblyWeakMap = typeof WeakMap === 'function' ? WeakMap : Map;
	  componentFrameCache = new PossiblyWeakMap();
	}

	function describeNativeComponentFrame(fn, construct) {
	  // If something asked for a stack inside a fake render, it should get ignored.
	  if ( !fn || reentry) {
	    return '';
	  }

	  {
	    var frame = componentFrameCache.get(fn);

	    if (frame !== undefined) {
	      return frame;
	    }
	  }

	  var control;
	  reentry = true;
	  var previousPrepareStackTrace = Error.prepareStackTrace; // $FlowFixMe It does accept undefined.

	  Error.prepareStackTrace = undefined;
	  var previousDispatcher;

	  {
	    previousDispatcher = ReactCurrentDispatcher.current; // Set the dispatcher in DEV because this might be call in the render function
	    // for warnings.

	    ReactCurrentDispatcher.current = null;
	    disableLogs();
	  }

	  try {
	    // This should throw.
	    if (construct) {
	      // Something should be setting the props in the constructor.
	      var Fake = function () {
	        throw Error();
	      }; // $FlowFixMe


	      Object.defineProperty(Fake.prototype, 'props', {
	        set: function () {
	          // We use a throwing setter instead of frozen or non-writable props
	          // because that won't throw in a non-strict mode function.
	          throw Error();
	        }
	      });

	      if (typeof Reflect === 'object' && Reflect.construct) {
	        // We construct a different control for this case to include any extra
	        // frames added by the construct call.
	        try {
	          Reflect.construct(Fake, []);
	        } catch (x) {
	          control = x;
	        }

	        Reflect.construct(fn, [], Fake);
	      } else {
	        try {
	          Fake.call();
	        } catch (x) {
	          control = x;
	        }

	        fn.call(Fake.prototype);
	      }
	    } else {
	      try {
	        throw Error();
	      } catch (x) {
	        control = x;
	      }

	      fn();
	    }
	  } catch (sample) {
	    // This is inlined manually because closure doesn't do it for us.
	    if (sample && control && typeof sample.stack === 'string') {
	      // This extracts the first frame from the sample that isn't also in the control.
	      // Skipping one frame that we assume is the frame that calls the two.
	      var sampleLines = sample.stack.split('\n');
	      var controlLines = control.stack.split('\n');
	      var s = sampleLines.length - 1;
	      var c = controlLines.length - 1;

	      while (s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c]) {
	        // We expect at least one stack frame to be shared.
	        // Typically this will be the root most one. However, stack frames may be
	        // cut off due to maximum stack limits. In this case, one maybe cut off
	        // earlier than the other. We assume that the sample is longer or the same
	        // and there for cut off earlier. So we should find the root most frame in
	        // the sample somewhere in the control.
	        c--;
	      }

	      for (; s >= 1 && c >= 0; s--, c--) {
	        // Next we find the first one that isn't the same which should be the
	        // frame that called our sample function and the control.
	        if (sampleLines[s] !== controlLines[c]) {
	          // In V8, the first line is describing the message but other VMs don't.
	          // If we're about to return the first line, and the control is also on the same
	          // line, that's a pretty good indicator that our sample threw at same line as
	          // the control. I.e. before we entered the sample frame. So we ignore this result.
	          // This can happen if you passed a class to function component, or non-function.
	          if (s !== 1 || c !== 1) {
	            do {
	              s--;
	              c--; // We may still have similar intermediate frames from the construct call.
	              // The next one that isn't the same should be our match though.

	              if (c < 0 || sampleLines[s] !== controlLines[c]) {
	                // V8 adds a "new" prefix for native classes. Let's remove it to make it prettier.
	                var _frame = '\n' + sampleLines[s].replace(' at new ', ' at '); // If our component frame is labeled "<anonymous>"
	                // but we have a user-provided "displayName"
	                // splice it in to make the stack more readable.


	                if (fn.displayName && _frame.includes('<anonymous>')) {
	                  _frame = _frame.replace('<anonymous>', fn.displayName);
	                }

	                {
	                  if (typeof fn === 'function') {
	                    componentFrameCache.set(fn, _frame);
	                  }
	                } // Return the line we found.


	                return _frame;
	              }
	            } while (s >= 1 && c >= 0);
	          }

	          break;
	        }
	      }
	    }
	  } finally {
	    reentry = false;

	    {
	      ReactCurrentDispatcher.current = previousDispatcher;
	      reenableLogs();
	    }

	    Error.prepareStackTrace = previousPrepareStackTrace;
	  } // Fallback to just using the name if we couldn't make it throw.


	  var name = fn ? fn.displayName || fn.name : '';
	  var syntheticFrame = name ? describeBuiltInComponentFrame(name) : '';

	  {
	    if (typeof fn === 'function') {
	      componentFrameCache.set(fn, syntheticFrame);
	    }
	  }

	  return syntheticFrame;
	}
	function describeFunctionComponentFrame(fn, source, ownerFn) {
	  {
	    return describeNativeComponentFrame(fn, false);
	  }
	}

	function shouldConstruct(Component) {
	  var prototype = Component.prototype;
	  return !!(prototype && prototype.isReactComponent);
	}

	function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {

	  if (type == null) {
	    return '';
	  }

	  if (typeof type === 'function') {
	    {
	      return describeNativeComponentFrame(type, shouldConstruct(type));
	    }
	  }

	  if (typeof type === 'string') {
	    return describeBuiltInComponentFrame(type);
	  }

	  switch (type) {
	    case REACT_SUSPENSE_TYPE:
	      return describeBuiltInComponentFrame('Suspense');

	    case REACT_SUSPENSE_LIST_TYPE:
	      return describeBuiltInComponentFrame('SuspenseList');
	  }

	  if (typeof type === 'object') {
	    switch (type.$$typeof) {
	      case REACT_FORWARD_REF_TYPE:
	        return describeFunctionComponentFrame(type.render);

	      case REACT_MEMO_TYPE:
	        // Memo may contain any component type so we recursively resolve it.
	        return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);

	      case REACT_LAZY_TYPE:
	        {
	          var lazyComponent = type;
	          var payload = lazyComponent._payload;
	          var init = lazyComponent._init;

	          try {
	            // Lazy may contain any component type so we recursively resolve it.
	            return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
	          } catch (x) {}
	        }
	    }
	  }

	  return '';
	}

	var hasOwnProperty = Object.prototype.hasOwnProperty;

	var loggedTypeFailures = {};
	var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;

	function setCurrentlyValidatingElement(element) {
	  {
	    if (element) {
	      var owner = element._owner;
	      var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
	      ReactDebugCurrentFrame.setExtraStackFrame(stack);
	    } else {
	      ReactDebugCurrentFrame.setExtraStackFrame(null);
	    }
	  }
	}

	function checkPropTypes(typeSpecs, values, location, componentName, element) {
	  {
	    // $FlowFixMe This is okay but Flow doesn't know it.
	    var has = Function.call.bind(hasOwnProperty);

	    for (var typeSpecName in typeSpecs) {
	      if (has(typeSpecs, typeSpecName)) {
	        var error$1 = void 0; // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.

	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          if (typeof typeSpecs[typeSpecName] !== 'function') {
	            // eslint-disable-next-line react-internal/prod-error-codes
	            var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' + 'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.');
	            err.name = 'Invariant Violation';
	            throw err;
	          }

	          error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED');
	        } catch (ex) {
	          error$1 = ex;
	        }

	        if (error$1 && !(error$1 instanceof Error)) {
	          setCurrentlyValidatingElement(element);

	          error('%s: type specification of %s' + ' `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error$1);

	          setCurrentlyValidatingElement(null);
	        }

	        if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error$1.message] = true;
	          setCurrentlyValidatingElement(element);

	          error('Failed %s type: %s', location, error$1.message);

	          setCurrentlyValidatingElement(null);
	        }
	      }
	    }
	  }
	}

	var isArrayImpl = Array.isArray; // eslint-disable-next-line no-redeclare

	function isArray(a) {
	  return isArrayImpl(a);
	}

	/*
	 * The `'' + value` pattern (used in in perf-sensitive code) throws for Symbol
	 * and Temporal.* types. See https://github.com/facebook/react/pull/22064.
	 *
	 * The functions in this module will throw an easier-to-understand,
	 * easier-to-debug exception with a clear errors message message explaining the
	 * problem. (Instead of a confusing exception thrown inside the implementation
	 * of the `value` object).
	 */
	// $FlowFixMe only called in DEV, so void return is not possible.
	function typeName(value) {
	  {
	    // toStringTag is needed for namespaced types like Temporal.Instant
	    var hasToStringTag = typeof Symbol === 'function' && Symbol.toStringTag;
	    var type = hasToStringTag && value[Symbol.toStringTag] || value.constructor.name || 'Object';
	    return type;
	  }
	} // $FlowFixMe only called in DEV, so void return is not possible.


	function willCoercionThrow(value) {
	  {
	    try {
	      testStringCoercion(value);
	      return false;
	    } catch (e) {
	      return true;
	    }
	  }
	}

	function testStringCoercion(value) {
	  // If you ended up here by following an exception call stack, here's what's
	  // happened: you supplied an object or symbol value to React (as a prop, key,
	  // DOM attribute, CSS property, string ref, etc.) and when React tried to
	  // coerce it to a string using `'' + value`, an exception was thrown.
	  //
	  // The most common types that will cause this exception are `Symbol` instances
	  // and Temporal objects like `Temporal.Instant`. But any object that has a
	  // `valueOf` or `[Symbol.toPrimitive]` method that throws will also cause this
	  // exception. (Library authors do this to prevent users from using built-in
	  // numeric operators like `+` or comparison operators like `>=` because custom
	  // methods are needed to perform accurate arithmetic or comparison.)
	  //
	  // To fix the problem, coerce this object or symbol value to a string before
	  // passing it to React. The most reliable way is usually `String(value)`.
	  //
	  // To find which value is throwing, check the browser or debugger console.
	  // Before this exception was thrown, there should be `console.error` output
	  // that shows the type (Symbol, Temporal.PlainDate, etc.) that caused the
	  // problem and how that type was used: key, atrribute, input value prop, etc.
	  // In most cases, this console output also shows the component and its
	  // ancestor components where the exception happened.
	  //
	  // eslint-disable-next-line react-internal/safe-string-coercion
	  return '' + value;
	}
	function checkKeyStringCoercion(value) {
	  {
	    if (willCoercionThrow(value)) {
	      error('The provided key is an unsupported type %s.' + ' This value must be coerced to a string before before using it here.', typeName(value));

	      return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
	    }
	  }
	}

	var ReactCurrentOwner = ReactSharedInternals.ReactCurrentOwner;
	var RESERVED_PROPS = {
	  key: true,
	  ref: true,
	  __self: true,
	  __source: true
	};
	var specialPropKeyWarningShown;
	var specialPropRefWarningShown;

	function hasValidRef(config) {
	  {
	    if (hasOwnProperty.call(config, 'ref')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;

	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }

	  return config.ref !== undefined;
	}

	function hasValidKey(config) {
	  {
	    if (hasOwnProperty.call(config, 'key')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;

	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }

	  return config.key !== undefined;
	}

	function warnIfStringRefCannotBeAutoConverted(config, self) {
	  {
	    if (typeof config.ref === 'string' && ReactCurrentOwner.current && self) ;
	  }
	}

	function defineKeyPropWarningGetter(props, displayName) {
	  {
	    var warnAboutAccessingKey = function () {
	      if (!specialPropKeyWarningShown) {
	        specialPropKeyWarningShown = true;

	        error('%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://reactjs.org/link/special-props)', displayName);
	      }
	    };

	    warnAboutAccessingKey.isReactWarning = true;
	    Object.defineProperty(props, 'key', {
	      get: warnAboutAccessingKey,
	      configurable: true
	    });
	  }
	}

	function defineRefPropWarningGetter(props, displayName) {
	  {
	    var warnAboutAccessingRef = function () {
	      if (!specialPropRefWarningShown) {
	        specialPropRefWarningShown = true;

	        error('%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://reactjs.org/link/special-props)', displayName);
	      }
	    };

	    warnAboutAccessingRef.isReactWarning = true;
	    Object.defineProperty(props, 'ref', {
	      get: warnAboutAccessingRef,
	      configurable: true
	    });
	  }
	}
	/**
	 * Factory method to create a new React element. This no longer adheres to
	 * the class pattern, so do not use new to call it. Also, instanceof check
	 * will not work. Instead test $$typeof field against Symbol.for('react.element') to check
	 * if something is a React Element.
	 *
	 * @param {*} type
	 * @param {*} props
	 * @param {*} key
	 * @param {string|object} ref
	 * @param {*} owner
	 * @param {*} self A *temporary* helper to detect places where `this` is
	 * different from the `owner` when React.createElement is called, so that we
	 * can warn. We want to get rid of owner and replace string `ref`s with arrow
	 * functions, and as long as `this` and owner are the same, there will be no
	 * change in behavior.
	 * @param {*} source An annotation object (added by a transpiler or otherwise)
	 * indicating filename, line number, and/or other information.
	 * @internal
	 */


	var ReactElement = function (type, key, ref, self, source, owner, props) {
	  var element = {
	    // This tag allows us to uniquely identify this as a React Element
	    $$typeof: REACT_ELEMENT_TYPE,
	    // Built-in properties that belong on the element
	    type: type,
	    key: key,
	    ref: ref,
	    props: props,
	    // Record the component responsible for creating this element.
	    _owner: owner
	  };

	  {
	    // The validation flag is currently mutative. We put it on
	    // an external backing store so that we can freeze the whole object.
	    // This can be replaced with a WeakMap once they are implemented in
	    // commonly used development environments.
	    element._store = {}; // To make comparing ReactElements easier for testing purposes, we make
	    // the validation flag non-enumerable (where possible, which should
	    // include every environment we run tests in), so the test framework
	    // ignores it.

	    Object.defineProperty(element._store, 'validated', {
	      configurable: false,
	      enumerable: false,
	      writable: true,
	      value: false
	    }); // self and source are DEV only properties.

	    Object.defineProperty(element, '_self', {
	      configurable: false,
	      enumerable: false,
	      writable: false,
	      value: self
	    }); // Two elements created in two different places should be considered
	    // equal for testing purposes and therefore we hide it from enumeration.

	    Object.defineProperty(element, '_source', {
	      configurable: false,
	      enumerable: false,
	      writable: false,
	      value: source
	    });

	    if (Object.freeze) {
	      Object.freeze(element.props);
	      Object.freeze(element);
	    }
	  }

	  return element;
	};
	/**
	 * https://github.com/reactjs/rfcs/pull/107
	 * @param {*} type
	 * @param {object} props
	 * @param {string} key
	 */

	function jsxDEV(type, config, maybeKey, source, self) {
	  {
	    var propName; // Reserved names are extracted

	    var props = {};
	    var key = null;
	    var ref = null; // Currently, key can be spread in as a prop. This causes a potential
	    // issue if key is also explicitly declared (ie. <div {...props} key="Hi" />
	    // or <div key="Hi" {...props} /> ). We want to deprecate key spread,
	    // but as an intermediary step, we will use jsxDEV for everything except
	    // <div {...props} key="Hi" />, because we aren't currently able to tell if
	    // key is explicitly declared to be undefined or not.

	    if (maybeKey !== undefined) {
	      {
	        checkKeyStringCoercion(maybeKey);
	      }

	      key = '' + maybeKey;
	    }

	    if (hasValidKey(config)) {
	      {
	        checkKeyStringCoercion(config.key);
	      }

	      key = '' + config.key;
	    }

	    if (hasValidRef(config)) {
	      ref = config.ref;
	      warnIfStringRefCannotBeAutoConverted(config, self);
	    } // Remaining properties are added to a new props object


	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    } // Resolve default props


	    if (type && type.defaultProps) {
	      var defaultProps = type.defaultProps;

	      for (propName in defaultProps) {
	        if (props[propName] === undefined) {
	          props[propName] = defaultProps[propName];
	        }
	      }
	    }

	    if (key || ref) {
	      var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;

	      if (key) {
	        defineKeyPropWarningGetter(props, displayName);
	      }

	      if (ref) {
	        defineRefPropWarningGetter(props, displayName);
	      }
	    }

	    return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
	  }
	}

	var ReactCurrentOwner$1 = ReactSharedInternals.ReactCurrentOwner;
	var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;

	function setCurrentlyValidatingElement$1(element) {
	  {
	    if (element) {
	      var owner = element._owner;
	      var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
	      ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
	    } else {
	      ReactDebugCurrentFrame$1.setExtraStackFrame(null);
	    }
	  }
	}

	var propTypesMisspellWarningShown;

	{
	  propTypesMisspellWarningShown = false;
	}
	/**
	 * Verifies the object is a ReactElement.
	 * See https://reactjs.org/docs/react-api.html#isvalidelement
	 * @param {?object} object
	 * @return {boolean} True if `object` is a ReactElement.
	 * @final
	 */


	function isValidElement(object) {
	  {
	    return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	  }
	}

	function getDeclarationErrorAddendum() {
	  {
	    if (ReactCurrentOwner$1.current) {
	      var name = getComponentNameFromType(ReactCurrentOwner$1.current.type);

	      if (name) {
	        return '\n\nCheck the render method of `' + name + '`.';
	      }
	    }

	    return '';
	  }
	}

	function getSourceInfoErrorAddendum(source) {
	  {

	    return '';
	  }
	}
	/**
	 * Warn if there's no key explicitly set on dynamic arrays of children or
	 * object keys are not valid. This allows us to keep track of children between
	 * updates.
	 */


	var ownerHasKeyUseWarning = {};

	function getCurrentComponentErrorInfo(parentType) {
	  {
	    var info = getDeclarationErrorAddendum();

	    if (!info) {
	      var parentName = typeof parentType === 'string' ? parentType : parentType.displayName || parentType.name;

	      if (parentName) {
	        info = "\n\nCheck the top-level render call using <" + parentName + ">.";
	      }
	    }

	    return info;
	  }
	}
	/**
	 * Warn if the element doesn't have an explicit key assigned to it.
	 * This element is in an array. The array could grow and shrink or be
	 * reordered. All children that haven't already been validated are required to
	 * have a "key" property assigned to it. Error statuses are cached so a warning
	 * will only be shown once.
	 *
	 * @internal
	 * @param {ReactElement} element Element that requires a key.
	 * @param {*} parentType element's parent's type.
	 */


	function validateExplicitKey(element, parentType) {
	  {
	    if (!element._store || element._store.validated || element.key != null) {
	      return;
	    }

	    element._store.validated = true;
	    var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType);

	    if (ownerHasKeyUseWarning[currentComponentErrorInfo]) {
	      return;
	    }

	    ownerHasKeyUseWarning[currentComponentErrorInfo] = true; // Usually the current owner is the offender, but if it accepts children as a
	    // property, it may be the creator of the child that's responsible for
	    // assigning it a key.

	    var childOwner = '';

	    if (element && element._owner && element._owner !== ReactCurrentOwner$1.current) {
	      // Give the component that originally created this child.
	      childOwner = " It was passed a child from " + getComponentNameFromType(element._owner.type) + ".";
	    }

	    setCurrentlyValidatingElement$1(element);

	    error('Each child in a list should have a unique "key" prop.' + '%s%s See https://reactjs.org/link/warning-keys for more information.', currentComponentErrorInfo, childOwner);

	    setCurrentlyValidatingElement$1(null);
	  }
	}
	/**
	 * Ensure that every element either is passed in a static location, in an
	 * array with an explicit keys property defined, or in an object literal
	 * with valid key property.
	 *
	 * @internal
	 * @param {ReactNode} node Statically passed child of any type.
	 * @param {*} parentType node's parent's type.
	 */


	function validateChildKeys(node, parentType) {
	  {
	    if (typeof node !== 'object') {
	      return;
	    }

	    if (isArray(node)) {
	      for (var i = 0; i < node.length; i++) {
	        var child = node[i];

	        if (isValidElement(child)) {
	          validateExplicitKey(child, parentType);
	        }
	      }
	    } else if (isValidElement(node)) {
	      // This element was passed in a valid location.
	      if (node._store) {
	        node._store.validated = true;
	      }
	    } else if (node) {
	      var iteratorFn = getIteratorFn(node);

	      if (typeof iteratorFn === 'function') {
	        // Entry iterators used to provide implicit keys,
	        // but now we print a separate warning for them later.
	        if (iteratorFn !== node.entries) {
	          var iterator = iteratorFn.call(node);
	          var step;

	          while (!(step = iterator.next()).done) {
	            if (isValidElement(step.value)) {
	              validateExplicitKey(step.value, parentType);
	            }
	          }
	        }
	      }
	    }
	  }
	}
	/**
	 * Given an element, validate that its props follow the propTypes definition,
	 * provided by the type.
	 *
	 * @param {ReactElement} element
	 */


	function validatePropTypes(element) {
	  {
	    var type = element.type;

	    if (type === null || type === undefined || typeof type === 'string') {
	      return;
	    }

	    var propTypes;

	    if (typeof type === 'function') {
	      propTypes = type.propTypes;
	    } else if (typeof type === 'object' && (type.$$typeof === REACT_FORWARD_REF_TYPE || // Note: Memo only checks outer props here.
	    // Inner props are checked in the reconciler.
	    type.$$typeof === REACT_MEMO_TYPE)) {
	      propTypes = type.propTypes;
	    } else {
	      return;
	    }

	    if (propTypes) {
	      // Intentionally inside to avoid triggering lazy initializers:
	      var name = getComponentNameFromType(type);
	      checkPropTypes(propTypes, element.props, 'prop', name, element);
	    } else if (type.PropTypes !== undefined && !propTypesMisspellWarningShown) {
	      propTypesMisspellWarningShown = true; // Intentionally inside to avoid triggering lazy initializers:

	      var _name = getComponentNameFromType(type);

	      error('Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?', _name || 'Unknown');
	    }

	    if (typeof type.getDefaultProps === 'function' && !type.getDefaultProps.isReactClassApproved) {
	      error('getDefaultProps is only used on classic React.createClass ' + 'definitions. Use a static property named `defaultProps` instead.');
	    }
	  }
	}
	/**
	 * Given a fragment, validate that it can only be provided with fragment props
	 * @param {ReactElement} fragment
	 */


	function validateFragmentProps(fragment) {
	  {
	    var keys = Object.keys(fragment.props);

	    for (var i = 0; i < keys.length; i++) {
	      var key = keys[i];

	      if (key !== 'children' && key !== 'key') {
	        setCurrentlyValidatingElement$1(fragment);

	        error('Invalid prop `%s` supplied to `React.Fragment`. ' + 'React.Fragment can only have `key` and `children` props.', key);

	        setCurrentlyValidatingElement$1(null);
	        break;
	      }
	    }

	    if (fragment.ref !== null) {
	      setCurrentlyValidatingElement$1(fragment);

	      error('Invalid attribute `ref` supplied to `React.Fragment`.');

	      setCurrentlyValidatingElement$1(null);
	    }
	  }
	}

	function jsxWithValidation(type, props, key, isStaticChildren, source, self) {
	  {
	    var validType = isValidElementType(type); // We warn in this case but don't throw. We expect the element creation to
	    // succeed and there will likely be errors in render.

	    if (!validType) {
	      var info = '';

	      if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
	        info += ' You likely forgot to export your component from the file ' + "it's defined in, or you might have mixed up default and named imports.";
	      }

	      var sourceInfo = getSourceInfoErrorAddendum();

	      if (sourceInfo) {
	        info += sourceInfo;
	      } else {
	        info += getDeclarationErrorAddendum();
	      }

	      var typeString;

	      if (type === null) {
	        typeString = 'null';
	      } else if (isArray(type)) {
	        typeString = 'array';
	      } else if (type !== undefined && type.$$typeof === REACT_ELEMENT_TYPE) {
	        typeString = "<" + (getComponentNameFromType(type.type) || 'Unknown') + " />";
	        info = ' Did you accidentally export a JSX literal instead of a component?';
	      } else {
	        typeString = typeof type;
	      }

	      error('React.jsx: type is invalid -- expected a string (for ' + 'built-in components) or a class/function (for composite ' + 'components) but got: %s.%s', typeString, info);
	    }

	    var element = jsxDEV(type, props, key, source, self); // The result can be nullish if a mock or a custom function is used.
	    // TODO: Drop this when these are no longer allowed as the type argument.

	    if (element == null) {
	      return element;
	    } // Skip key warning if the type isn't valid since our key validation logic
	    // doesn't expect a non-string/function type and can throw confusing errors.
	    // We don't want exception behavior to differ between dev and prod.
	    // (Rendering will throw with a helpful message and as soon as the type is
	    // fixed, the key warnings will appear.)


	    if (validType) {
	      var children = props.children;

	      if (children !== undefined) {
	        if (isStaticChildren) {
	          if (isArray(children)) {
	            for (var i = 0; i < children.length; i++) {
	              validateChildKeys(children[i], type);
	            }

	            if (Object.freeze) {
	              Object.freeze(children);
	            }
	          } else {
	            error('React.jsx: Static children should always be an array. ' + 'You are likely explicitly calling React.jsxs or React.jsxDEV. ' + 'Use the Babel transform instead.');
	          }
	        } else {
	          validateChildKeys(children, type);
	        }
	      }
	    }

	    if (type === REACT_FRAGMENT_TYPE) {
	      validateFragmentProps(element);
	    } else {
	      validatePropTypes(element);
	    }

	    return element;
	  }
	} // These two functions exist to still get child warnings in dev
	// even with the prod transform. This means that jsxDEV is purely
	// opt-in behavior for better messages but that we won't stop
	// giving you warnings if you use production apis.

	function jsxWithValidationStatic(type, props, key) {
	  {
	    return jsxWithValidation(type, props, key, true);
	  }
	}
	function jsxWithValidationDynamic(type, props, key) {
	  {
	    return jsxWithValidation(type, props, key, false);
	  }
	}

	var jsx =  jsxWithValidationDynamic ; // we may want to special case jsxs internally to take advantage of static children.
	// for now we can ship identical prod functions

	var jsxs =  jsxWithValidationStatic ;

	reactJsxRuntime_development.Fragment = REACT_FRAGMENT_TYPE;
	reactJsxRuntime_development.jsx = jsx;
	reactJsxRuntime_development.jsxs = jsxs;
	  })();
	}
	return reactJsxRuntime_development;
}

var hasRequiredJsxRuntime;

function requireJsxRuntime () {
	if (hasRequiredJsxRuntime) return jsxRuntime.exports;
	hasRequiredJsxRuntime = 1;

	if (process.env.NODE_ENV === 'production') {
	  jsxRuntime.exports = requireReactJsxRuntime_production_min();
	} else {
	  jsxRuntime.exports = requireReactJsxRuntime_development();
	}
	return jsxRuntime.exports;
}

var jsxRuntimeExports = requireJsxRuntime();

const MsgPolycardContextError = 'usePolycardContext must be used within a PolycardContext';
const MsgCardContextError = 'useCardContext must be used within a useCardContext';
const MsgThousandDecimalError = 'The Thousand Separator or Decimal Separator is not defined in Polycard';

const cardContext = createContext(undefined);
const CardContext = ({ contextValue, children }) => {
    const { url, onClick, metadata: { item_ids_for_removal, id }, } = contextValue;
    const handleClick = (event) => {
        if (onClick) {
            onClick(event, { url, id, item_ids_for_removal });
        }
    };
    const value = { ...contextValue, onClick: handleClick };
    return jsxRuntimeExports.jsx(cardContext.Provider, { value: value, children: children });
};
function useCardContext() {
    const context = useContext(cardContext);
    if (context === undefined) {
        throw new Error(MsgCardContextError);
    }
    return context;
}

const Devices = ['mobile', 'tablet', 'desktop'];

const PictureSizes = [
    'F',
    'B',
    'O',
    'C',
    'V',
    'E',
    'P',
    'A',
    'AB',
    'Y',
    'N',
    'T',
    'G',
    'I',
    'R',
    'M',
    'W',
    'Q',
];

const PictureSquares = ['NQ', 'Q'];

const isMobile = (device) => {
    if (device && Object.values(Devices).includes(device))
        return device === 'mobile';
    return false;
};
const isTablet = (device) => {
    if (device && Object.values(Devices).includes(device))
        return device === 'tablet';
    return false;
};

const polycardContext = createContext(undefined);
const PolycardContext = ({ contextValue, deviceType, actionCallbacks, children, thousandSeparator, decimalSeparator, countPreloadImages, isNavigableToVariation, lowEnd, targetLink, }) => {
    const value = useMemo(() => ({
        ...contextValue,
        deviceType,
        isMobile: isMobile(deviceType),
        isTablet: isTablet(deviceType),
        actionCallbacks,
        thousandSeparator,
        decimalSeparator,
        countPreloadImages,
        isNavigableToVariation: isMobile(deviceType) || isNavigableToVariation,
        lowEnd,
        targetLink,
        card_size: contextValue?.card_size || 'large',
    }), [
        contextValue,
        deviceType,
        actionCallbacks,
        thousandSeparator,
        decimalSeparator,
        countPreloadImages,
        isNavigableToVariation,
        targetLink,
        lowEnd,
    ]);
    return jsxRuntimeExports.jsx(polycardContext.Provider, { value: value, children: children });
};
function usePolycardContext() {
    const context = useContext(polycardContext);
    if (context === undefined) {
        throw new Error(MsgPolycardContextError);
    }
    return context;
}

const useEvaluationsCard = ({ type, isMobile, isTablet, deviceType, image_ratio, pictures, image_square, vertical_id, card_size, }) => {
    const evaluations = useMemo(() => {
        const isGrid = Boolean(type?.includes('grid'));
        const isSingle = Boolean(type?.includes('single'));
        const isList = Boolean(type?.includes('list'));
        const isTwoCols = isList && deviceType === 'desktop';
        const isImageReSize = image_ratio && isMobile && isList && card_size === 'large';
        const isListHeight = Boolean(isImageReSize && Number(image_ratio) < 0.9);
        const isGridHeight = isMobile && isGrid && vertical_id !== 'RES' && card_size === 'large';
        const isCarousel = !!pictures?.pictures && pictures?.pictures.length > 1;
        const squareMobile = image_square && isMobile && card_size === 'large' ? image_square : undefined;
        const Imagewrapper = isListHeight && !isCarousel ? 'figure' : Fragment;
        const shouldDisplayLabelPill = isGrid && !isMobile && card_size === 'large';
        const isDesktop = !isMobile && !isTablet;
        return {
            isGrid,
            isSingle,
            isList,
            isTwoCols,
            isListHeight,
            isGridHeight,
            isCarousel,
            squareMobile,
            Imagewrapper,
            shouldDisplayLabelPill,
            isDesktop,
        };
    }, [
        type,
        isMobile,
        isTablet,
        deviceType,
        image_ratio,
        pictures,
        image_square,
        vertical_id,
        card_size,
    ]);
    return evaluations;
};

const getMarginsY = (element) => {
    try {
        const marginsHeight = parseInt(window?.getComputedStyle(element).marginTop, 10) +
            parseInt(window?.getComputedStyle(element).marginBottom, 10);
        return marginsHeight;
    }
    catch (error) {
        return 0;
    }
};
const measuringFlag = (reference, layoutType = 'grid-card') => Boolean(reference && reference.querySelectorAll(`.poly-card--${layoutType}`));
const measuringHeight = (reference, layoutType = 'grid-card') => {
    try {
        const cardClassNameHeader = 'poly-card__portada';
        const cardClassNameBody = `poly-card--${layoutType} .poly-card__content`;
        const cardClassNameFooter = `poly-card--${layoutType} .poly-card__footer`;
        const headerTagArray = Array.from(reference.querySelectorAll(`.${cardClassNameHeader}`));
        const bodyTagArray = Array.from(reference.querySelectorAll(`.${cardClassNameBody}:not(.${cardClassNameHeader})`));
        const footerTagArray = Array.from(reference.querySelectorAll(`.${cardClassNameFooter}`));
        const maxHeaderHeight = headerTagArray
            .map((item) => item.getBoundingClientRect().height)
            .sort((a, b) => b - a)[0] + getMarginsY(headerTagArray[0]);
        const maxBodyHeight = bodyTagArray
            .map((item) => item.getBoundingClientRect().height)
            .sort((a, b) => b - a)[0];
        const maxBodyFooter = footerTagArray
            .map((item) => item.getBoundingClientRect().height)
            .sort((a, b) => b - a)[0] ?? 0;
        const height = layoutType.includes('list')
            ? Math.max(maxBodyHeight, maxHeaderHeight)
            : maxBodyHeight + maxHeaderHeight + maxBodyFooter;
        return Number.isNaN(height) ? 0 : height;
    }
    catch (error) {
        return 0;
    }
};

const cardNamespace = 'poly';

const getListMap = (item) => {
    if (!item.column)
        return [item, null, null];
    if (item.column === 1)
        return [null, item, null];
    if (item.column === 2)
        return [null, null, item];
    return [null, null, null];
};
const getPrev = (prev) => prev ?? [];
const getCurr = (curr) => (curr ? [curr] : []);
const getReduceMap = (prev, curr) => [
    [...getPrev(prev[0]), ...getCurr(curr[0])],
    [...getPrev(prev[1]), ...getCurr(curr[1])],
    [...getPrev(prev[2]), ...getCurr(curr[2])],
];
const getColProps = (isTwoCols, components) => {
    const [col, col1, col2] = isTwoCols
        ? components.map(getListMap).reduce(getReduceMap, [[], [], []])
        : [components, [], []];
    return [{ components: col }, { components: col1 }, { components: col2 }];
};

const getKey = (base, itemId, index) => {
    if (typeof base !== 'string') {
        if (base.type === 'pill') {
            return base.pill?.text?.toLowerCase()?.split(' ')?.join('_') ?? 'pill_empty';
        }
        return `${base.id ?? base.type}-${itemId}${''}`;
    }
    return `${base}-${itemId}${''}`;
};

const getUrl = (metadata, url_params, url_prefix, url_params_default, url_fragments_default, url_fragments_variations, url_variations) => {
    const { url: url_meta, url_fragments: url_fragments_metadata, url_params: url_params_metadata, } = metadata;
    const variationParams = url_params && `?${url_params}`;
    const url_base = url_variations ?? url_meta;
    if (!url_base) {
        return '';
    }
    const urlHasPrefix = url_base.startsWith('https://') || url_base.startsWith('meli://');
    const prefix = !urlHasPrefix && !!url_prefix ? url_prefix : '';
    const params = variationParams ?? url_params_metadata ?? url_params_default ?? '';
    const fragments = url_fragments_variations ?? url_fragments_metadata ?? url_fragments_default ?? '';
    return `${prefix}${url_base}${params}${fragments}`;
};

const regex = /{(.*?)}/gm;
const interpolationMatcher = (text) => text?.match(regex);

const namespace$k = `${cardNamespace}-action`;
const Action = ({ text, callback, type = 'link', hierarchy, values }) => {
    const { metadata } = useCardContext();
    const { card_size } = usePolycardContext();
    const id = metadata.item_ids_for_removal || metadata.id;
    const matchValue = interpolationMatcher(text);
    const handleSubmit = (event) => {
        if (callback) {
            callback(event, id, metadata);
        }
    };
    const formatText = () => {
        if (!matchValue)
            return text;
        return jsxRuntimeExports.jsx(Phrase, { text: text, isAsText: false, values: values });
    };
    return (jsxRuntimeExports.jsxs("div", { "data-testid": "form-action", className: namespace$k, children: [jsxRuntimeExports.jsx("input", { type: "hidden", name: "id", value: id, "data-testid": "form-data-id" }), type === 'link' ? (jsxRuntimeExports.jsx("button", { className: `${namespace$k}__button`, type: "button", onClick: handleSubmit, children: formatText() })) : (jsxRuntimeExports.jsx(Button, { type: "submit", hierarchy: hierarchy, onClick: handleSubmit, size: card_size, children: jsxRuntimeExports.jsx(ButtonText, { children: formatText() }) }))] }));
};

const namespace$j = `${cardNamespace}-component__link`;
const Link = ({ rel, url, text, children, className, classModified, onClick, target, type = 'link', hierarchy, values, }) => {
    const { card_size } = usePolycardContext();
    const matchValue = interpolationMatcher(text);
    if ((!text || !children) && !url)
        return null;
    const linkClasess = classnames(className, namespace$j, {
        [`${namespace$j}--${classModified}`]: !!classModified,
    });
    const formatText = () => {
        if (!text)
            return children;
        if (!matchValue)
            return text;
        return jsxRuntimeExports.jsx(Phrase, { text: text, isAsText: false, values: values });
    };
    return type === 'link' ? (jsxRuntimeExports.jsx("a", { href: url, className: linkClasess, onClick: onClick, rel: rel, target: target, children: formatText() })) : (jsxRuntimeExports.jsx(Button, { href: url, hierarchy: hierarchy, size: card_size, children: jsxRuntimeExports.jsx(ButtonText, { children: formatText() }) }));
};

const namespace$i = `${cardNamespace}-action-links`;
const ActionLinks = ({ action_links, className }) => {
    const { actionCallbacks } = usePolycardContext();
    const hasButtons = action_links?.some(({ type }) => type === 'button');
    const wrapperClasses = classnames(namespace$i, className, {
        [`${className}--buttons`]: hasButtons,
    });
    return (jsxRuntimeExports.jsx("div", { className: wrapperClasses, children: action_links?.map((action) => {
            const actionCallback = actionCallbacks
                ? actionCallbacks.find(({ id }) => id === action.id)
                : null;
            const actionComponent = actionCallback && actionCallback.callback ? (jsxRuntimeExports.jsx(Action, { ...action, callback: actionCallback.callback })) : (jsxRuntimeExports.jsx(Link, { ...action, classModified: "action-link" }));
            const containerClasses = classnames(`${namespace$i}__action`, {
                [`${namespace$i}__action--${action.type}`]: !!action.type,
            });
            return (jsxRuntimeExports.jsx("div", { className: containerClasses, children: actionComponent }, action.id));
        }) }));
};

const BaseText = ({ alt_text, className, styles, target, text, url, values, }) => {
    const { thousandSeparator, decimalSeparator } = usePolycardContext();
    return (jsxRuntimeExports.jsx(Phrase, { alt_text: alt_text, className: className, styles: styles, target: target, text: text, url: url, values: values, thousandSeparator: thousandSeparator, decimalSeparator: decimalSeparator }));
};
const BlockText = (props) => jsxRuntimeExports.jsx(BaseText, { ...props });

const namespace$h = `${cardNamespace}-bookmark`;
const componentNameSpace$2 = `${cardNamespace}-component__bookmark`;
const Bookmark = () => {
    const { metadata, bookmark: bookmarkComponent } = useCardContext();
    if (!bookmarkComponent) {
        return null;
    }
    const { bookmarkAction, bookmarked, alt_text } = bookmarkComponent;
    const handleSubmit = (event) => {
        event.preventDefault();
        if (bookmarkAction) {
            bookmarkAction(event, metadata.id);
        }
    };
    const bookmarkClassName = classnames(componentNameSpace$2);
    const btnClassName = classnames(`${namespace$h}__btn`, {
        [`${namespace$h}__btn--active`]: bookmarked,
    });
    const iconClassNameFull = classnames(`${namespace$h}__icon-full`);
    const IconClassNameEmpty = classnames(`${namespace$h}__icon-empty`);
    const values = [
        { type: 'icon', key: 'icon_bookmark', icon: { key: 'bookmark' } },
    ];
    return (jsxRuntimeExports.jsx("div", { className: bookmarkClassName, "data-testid": "bookmark", children: jsxRuntimeExports.jsxs("button", { type: "button", className: btnClassName, role: "switch", "aria-checked": bookmarked, "aria-label": alt_text || 'favorito', onClick: handleSubmit, children: [jsxRuntimeExports.jsx(Phrase, { text: "{icon_bookmark}", iconClassName: iconClassNameFull, isAsText: false, values: values }), jsxRuntimeExports.jsx(Phrase, { text: "{icon_bookmark}", iconClassName: IconClassNameEmpty, isAsText: false, values: values })] }) }));
};

const ImageOverlay = ({ overlay }) => {
    const { isMobile, picture_overlay_default } = usePolycardContext();
    const { metadata: { vertical_id }, } = useCardContext();
    const pictureOverlay = overlay ?? picture_overlay_default;
    // Devuelve null si no quieres renderizar nada
    const shouldRenderOverlay = pictureOverlay !== undefined ? pictureOverlay : isMobile && vertical_id === 'CORE';
    return shouldRenderOverlay ? jsxRuntimeExports.jsx("span", { className: "poly-component__image-overlay" }) : null;
};

const Loading = () => {
    const [progress, setProgress] = useState(0);
    const { metadata } = useCardContext();
    const { isLoading } = metadata;
    useEffect(() => {
        if (isLoading && progress < 100) {
            const interval = setInterval(() => {
                setProgress(progress + 1);
            }, 20);
            return () => {
                clearInterval(interval); // Limpia el intervalo al desmontar el componente
            };
        }
        setProgress(0);
        return () => { }; // Return an empty function to satisfy the expected return value
    }, [isLoading, progress]);
    return (isLoading && (jsxRuntimeExports.jsx("div", { className: "poly-component__loading", children: jsxRuntimeExports.jsx(ProgressIndicatorLinear, { id: "poly-progress-indicator-linear", srAnnouncement: "Cargando...", srLabel: `Progreso de subida ${{ progress }}`, value: progress }) })));
};

const lazyOn = 'on';
const lazyOff = 'off';

const getURLs = (picture_template, vars) => picture_template.replace(/{(\w+|\d+x)}/g, (_, key) => vars[key] || '');

const componentNameSpace$1 = `${cardNamespace}-component__picture`;
const Picture = ({ square, size, isCarousel, lazyload, preload, alt, id, className, src, sanitized_title, ariaHidden = false, }) => {
    const { picture_template, picture_size_default, picture_square_default, lowEnd = false, isMobile, card_size, } = usePolycardContext();
    const { metadata: { vertical_id }, } = useCardContext();
    const squareValue = square ?? picture_square_default;
    const sizeValue = size ?? picture_size_default;
    const srcURL_2X = !src &&
        getURLs(picture_template, {
            square: squareValue,
            '2x': '_2X',
            id,
            size: sizeValue,
            sanitized_title,
        });
    return (jsxRuntimeExports.jsx(Image, { className: classnames(className, componentNameSpace$1, {
            [`${componentNameSpace$1}--contain`]: (squareValue === 'Q' && vertical_id === 'MOT') ||
                (vertical_id !== 'RES' && isMobile && card_size === 'large'),
        }), carousel: isCarousel, lazyload: lazyload ? lazyOn : lazyOff, lowEnd: lowEnd, preload: preload, src: src || srcURL_2X, alt: alt || '', title: alt || null, width: 150, height: 150, "aria-hidden": ariaHidden }));
};

const namespace$g = `${cardNamespace}-component__carousel`;
const Carousel = ({ url, size, title, alt_text, pictures, variationId, onClick, square, sanitized_title, }) => {
    const [currentSlide, setCurrentSlide] = useState(0);
    const { onAfterImageChange } = useCardContext();
    const { isMobile, targetLink, isTablet } = usePolycardContext();
    const [carouselModule, setCarouselModule] = useState(null);
    // Importar la librería de forma dinámica
    useEffect(() => {
        import('@andes/carousel-snapped')
            .then((modulo) => {
            setCarouselModule(modulo);
        })
            .catch((error) => {
            // eslint-disable-next-line no-console
            console.error('Error al importar la librería:', error);
        });
    }, []);
    const handleAfterImageChange = (slideIndex) => {
        if (onAfterImageChange) {
            onAfterImageChange(slideIndex);
        }
    };
    return (carouselModule && (jsxRuntimeExports.jsx(carouselModule.default, { className: classnames(namespace$g, {
            [`${namespace$g}--bg-white `]: currentSlide > 0,
        }), pagination: pictures.length > 1 && pictures.length < 6 && isMobile, type: "full", arrows: {
            visibility: isMobile || isTablet ? 'always' : 'hover', // default: 'always'
        }, lazyload: true, srLabel: title, beforeChange: (_currentSlide, _newSlide) => setCurrentSlide(_newSlide), afterChange: handleAfterImageChange, children: pictures.map(({ id, alt, preload, lazyload }, index) => {
            const isPreload = preload ?? false;
            const islazyload = lazyload ?? false;
            const altText = alt ?? `${title} ${alt_text ?? ''} - ${index + 1}/${pictures.length}`;
            return (jsxRuntimeExports.jsx(carouselModule.CarouselSnappedSlide, { children: jsxRuntimeExports.jsx(Link, { url: url, onClick: onClick, classModified: "carousel", target: targetLink, children: jsxRuntimeExports.jsx(Picture, { id: id, alt: altText, preload: isPreload, lazyload: islazyload, square: square, size: size, sanitized_title: sanitized_title, isCarousel: true }) }) }, id));
        }) }, `${variationId}-${pictures[0].id}-${pictures.length}`)));
};

const namespace$f = `${cardNamespace}-component`;
const ImagesContainer = ({ alt_text, Imagewrapper, isCarousel, isListHeight, overlay, pictures, sanitized_title, size, square, }) => {
    const { countPreloadImages, isMobile, isTablet } = usePolycardContext();
    const { cardNumber, useLazyImage, isHover = false, onClick, url, title, metadata, } = useCardContext();
    const [isCarouselAlreadyRendered, setIsCarouselAlreadyRendered] = useState(false);
    const { vertical_id } = metadata;
    const { id, alt, preload, lazyload } = pictures[0];
    // calculamos si la imagen no debe ser lazy
    const isNotLazy = !!countPreloadImages && !!cardNumber && cardNumber <= countPreloadImages;
    const isPreload = preload ?? false;
    const islazyload = lazyload ?? !isPreload;
    useEffect(() => {
        const shouldRenderCarousel = () => {
            if (isCarouselAlreadyRendered)
                return false;
            if (!isMobile && isCarousel && isHover)
                return true;
            if ((isMobile && vertical_id === 'RES') || isTablet)
                return true;
            return false;
        };
        const shouldRender = shouldRenderCarousel();
        if (shouldRender) {
            setIsCarouselAlreadyRendered(true);
            if (window.imageLazyLoading) {
                window.imageLazyLoading('lazy-loadable', { loadMode: 'lazyload' });
            }
        }
    }, [isCarouselAlreadyRendered, isCarousel, isHover, isMobile, isTablet, vertical_id]);
    const memoCarouselComponent = useMemo(() => {
        if (isCarouselAlreadyRendered) {
            return (jsxRuntimeExports.jsx(Carousel, { url: url, size: size, pictures: pictures, variationId: pictures[0].id, square: square, onClick: onClick, title: title, alt_text: alt_text, sanitized_title: sanitized_title }));
        }
        return jsxRuntimeExports.jsx("span", {});
    }, [isCarouselAlreadyRendered, onClick, pictures, size, title, url, square, alt_text]);
    return (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [jsxRuntimeExports.jsx(Loading, {}), isCarouselAlreadyRendered && isCarousel && memoCarouselComponent, !isCarouselAlreadyRendered && jsxRuntimeExports.jsx(ImageOverlay, { overlay: overlay }), jsxRuntimeExports.jsx(Imagewrapper, { ...(isMobile && {
                    className: classnames(`${namespace$f}__image-wrapper`, {
                        [`${namespace$f}__image-wrapper--image-height`]: isListHeight,
                    }),
                }), children: jsxRuntimeExports.jsx(Picture, { id: id, alt: alt || title, size: size, square: square, preload: isPreload || isNotLazy, lazyload: useLazyImage ?? (islazyload && !isNotLazy), isCarousel: isCarousel, sanitized_title: sanitized_title, ariaHidden: true }) })] }));
};

const namespace$e = `${cardNamespace}-card__checkbox`;
const Checkbox = ({ className }) => {
    const { checkbox } = usePolycardContext();
    const { metadata, checkbox: checkboxComponent } = useCardContext();
    if (!checkbox || !checkboxComponent) {
        return null;
    }
    const { handleCheckbox, checked } = checkboxComponent;
    const handleCheckboxChange = (event) => {
        if (handleCheckbox) {
            handleCheckbox(event, metadata.id);
        }
    };
    return (jsxRuntimeExports.jsx("div", { className: classnames(className, `${namespace$e}`), children: jsxRuntimeExports.jsx(CheckboxAndes, { checked: checked, onChange: handleCheckboxChange }) }));
};

const AndesCard = ({ children, className, styles, paddingSize, forwardedRef, onMouseEnter, onMouseLeave, }) => {
    const { isHover } = useCardContext();
    const shadowType = isHover ? 'elevated' : 'flat';
    return (jsxRuntimeExports.jsx(CardUI, { paddingSize: paddingSize ?? 0, className: className, shadow: shadowType, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, animated: true, style: styles, ref: forwardedRef, children: children }));
};

const DynamicElement = ({ tagName, forwardedRef, children, className, style, ...props }) => React.createElement(tagName, { ...props, ref: forwardedRef, className, style }, children);

const Layout = forwardRef(({ children, className, styles, as = 'div', id, onMouseEnter, onMouseLeave }, ref) => {
    const { type } = usePolycardContext();
    const commonProps = {
        forwardedRef: ref,
        className,
        styles,
        onMouseEnter,
        onMouseLeave,
        id,
    };
    switch (type) {
        case 'list':
        case 'list-multicolumn':
        case 'single':
            return (jsxRuntimeExports.jsxs(DynamicElement, { tagName: as, ...commonProps, children: [type.startsWith('list') && jsxRuntimeExports.jsx(Checkbox, {}), children] }));
        case 'list-card':
        case 'grid-card':
            return (jsxRuntimeExports.jsx(AndesCard, { paddingSize: type === 'grid-card' ? 0 : undefined, ...commonProps, children: children }));
        default:
            return (jsxRuntimeExports.jsx(DynamicElement, { tagName: as, ...commonProps, children: children }));
    }
});

const namespace$d = `${cardNamespace}-suggestions`;
const componentNameSpace = `${cardNamespace}-component__suggestions`;
const Suggestions = () => {
    const [isClosing, setIsClosing] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const { type } = usePolycardContext();
    const { suggestions, needSuggestions, setNeedSuggestions, addToCartActions } = useCardContext();
    useEffect(() => {
        if (needSuggestions && suggestions) {
            setIsOpen(true);
            setIsClosing(false);
        }
        else {
            setIsOpen(false);
            setIsClosing(true);
        }
    }, [needSuggestions, suggestions]);
    const handleClose = () => {
        if (setNeedSuggestions) {
            setIsOpen(false);
            setNeedSuggestions(false);
            setIsClosing(true);
        }
    };
    const handleActionClick = (tag) => {
        if (addToCartActions && addToCartActions['handleSuggestionsButtonTrack']) {
            addToCartActions['handleSuggestionsButtonTrack'](tag);
        }
    };
    const mainClassName = classnames(componentNameSpace, `${componentNameSpace}--${type === 'list-multicolumn' ? 'list' : type}`, {
        [`${componentNameSpace}--close`]: isClosing,
        [`${componentNameSpace}--open`]: isOpen,
    });
    return suggestions ? (jsxRuntimeExports.jsxs("div", { className: `${mainClassName}`, role: "region", "aria-labelledby": "suggestions-title", children: [jsxRuntimeExports.jsxs("div", { className: `${namespace$d}__header`, children: [jsxRuntimeExports.jsxs("div", { className: `${namespace$d}__header-title`, children: [jsxRuntimeExports.jsx(Phrase, { text: "{spotlight_compatible_green_icon}", isAsText: false }), jsxRuntimeExports.jsx("h3", { id: "suggestions-title", className: `${namespace$d}__title`, children: suggestions?.title.text })] }), jsxRuntimeExports.jsx("button", { className: `${namespace$d}__close`, onClick: handleClose, type: "button", "aria-label": suggestions?.close_button?.text, children: jsxRuntimeExports.jsx(Phrase, { text: "{icon_close}", isAsText: false, values: [
                                { key: 'icon_close', type: 'icon', icon: { key: 'icon_close', alt_text: '' } },
                            ] }) })] }), jsxRuntimeExports.jsxs("div", { className: `${namespace$d}__content`, children: [jsxRuntimeExports.jsx("h3", { className: `${namespace$d}__subtitle`, id: "suggestions-subtitle", children: suggestions?.subtitle.text }), jsxRuntimeExports.jsx("ul", { className: `${namespace$d}__list`, "aria-labelledby": "suggestions-subtitle", children: suggestions?.tags.map((tag) => (jsxRuntimeExports.jsx("li", { className: `${namespace$d}__item`, children: jsxRuntimeExports.jsx("a", { className: `${namespace$d}__link`, onClick: () => handleActionClick(tag), href: tag.url, "aria-label": `${tag.name}`, children: jsxRuntimeExports.jsx(Tag, { label: tag.name, className: `${namespace$d}__tag` }) }) }, `${tag.category_id}`))) })] })] })) : null;
};

const namespace$c = `${cardNamespace}-add-to-cart`;
const AddToCartButton = ({ text, cart_status, cart_config }) => {
    const [isInCart, setIsInCart] = useState(cart_status && cart_status?.quantity !== 0);
    const [hasCalledFirst, setHasCalledFirst] = useState(false);
    const { addToCartActions, setNeedSuggestions } = useCardContext();
    const { metadata, url } = useCardContext();
    const { id } = metadata;
    const handleActionClick = (action, e, isFirstCall = false) => {
        if (addToCartActions) {
            addToCartActions[action]?.(e, url, id);
        }
        if (isFirstCall && setNeedSuggestions) {
            setNeedSuggestions(true);
            setHasCalledFirst(true);
        }
    };
    useEffect(() => {
        if (cart_status) {
            setIsInCart(cart_status.quantity !== 0);
            if (cart_status.quantity === 0 && setNeedSuggestions) {
                setNeedSuggestions(false);
                setHasCalledFirst(false);
            }
        }
    }, [cart_status, cart_status?.quantity]);
    return isInCart ? (jsxRuntimeExports.jsx(InputStepper, { className: `${namespace$c}__button--steper`, srLabel: `${cart_status?.quantity} ${cart_status?.quantity}`, complementaryText: cart_status?.text, decrementButtonProps: {
            onClick: (e) => handleActionClick('handleAddToCartDelete', e, !hasCalledFirst),
        }, id: id, incrementButtonProps: {
            onClick: (e) => handleActionClick('handleAddToCartPut', e, !hasCalledFirst),
        }, maxValue: cart_config?.max_add_quantity, size: "small", value: cart_status?.quantity, formatValue: (value) => cart_status?.format_value || value })) : (jsxRuntimeExports.jsx(Button, { className: `${namespace$c}__button--no-items`, fullWidth: true, hierarchy: "quiet", size: "medium", onClick: (e) => handleActionClick('handleAddToCartPut', e, !hasCalledFirst), children: jsxRuntimeExports.jsx(ButtonText, { children: text }) }));
};

const namespace$b = `${cardNamespace}-add-to-cart`;
const MinQuantityLabel = (props) => props && jsxRuntimeExports.jsx(Phrase, { className: `${namespace$b}__minimum-label`, ...props });

const namespace$a = `${cardNamespace}-add-to-cart`;
const OtherOptionsButton = ({ text, url, target }) => {
    const { addToCartActions } = useCardContext();
    const handleActionClick = () => {
        if (addToCartActions && addToCartActions['handleAddToCartButtonTrack']) {
            addToCartActions['handleAddToCartButtonTrack']();
        }
    };
    return (jsxRuntimeExports.jsx(Button, { className: `${namespace$a}__button--other-options`, fullWidth: true, hierarchy: "quiet", href: url, target: target, size: "medium", onClick: () => handleActionClick(), children: jsxRuntimeExports.jsx(ButtonText, { children: text }) }));
};

const namespace$9 = `${cardNamespace}-add-to-cart`;
const ShippingLabel = ({ text, styles, values }) => {
    const { thousandSeparator, decimalSeparator } = usePolycardContext();
    if (!thousandSeparator || !decimalSeparator) {
        console.error(MsgThousandDecimalError);
        return null;
    }
    return (jsxRuntimeExports.jsx(Phrase, { className: `${namespace$9}__shipping-label`, text: text, styles: styles, values: values, thousandSeparator: thousandSeparator, decimalSeparator: decimalSeparator }));
};

const AddToCart = ({ text, url, target, className, ...props }) => {
    const { cart_config, cart_shipping } = props;
    const { type } = usePolycardContext();
    return (jsxRuntimeExports.jsxs("div", { className: className, children: [cart_shipping && jsxRuntimeExports.jsx(ShippingLabel, { ...cart_shipping }), (type?.includes('grid') || type?.includes('single')) && jsxRuntimeExports.jsx(Suggestions, {}), url ? (jsxRuntimeExports.jsx(OtherOptionsButton, { text: text, url: url, target: target })) : (jsxRuntimeExports.jsx(AddToCartButton, { text: text, ...props })), cart_config && cart_config.min_add_text && (jsxRuntimeExports.jsx(MinQuantityLabel, { ...cart_config.min_add_text }))] }));
};

const AttributesList = ({ texts, separator, className, type }) => {
    const namespace = `${cardNamespace}-${type}`;
    return (jsxRuntimeExports.jsx("div", { className: className, children: jsxRuntimeExports.jsx("ul", { className: namespace, style: {
                '--separator-content': `"${separator}"`,
                gap: separator === ',' ? '0px' : '4px',
            }, children: texts?.map((text) => (jsxRuntimeExports.jsx("li", { className: classnames(`${namespace}__item`, [`${namespace}__separator`, !!separator]), children: text }, text?.toLowerCase().replace(' ', '-')))) }) }));
};

const className = 'poly-buy-box__alternative-option';
const AlternativeOption = ({ url, target, components }) => (jsxRuntimeExports.jsx(Link, { url: url, target: target, className: className, children: jsxRuntimeExports.jsx(ListComponents, { components: components }) }));

const namespace$8 = `${cardNamespace}-buy-box`;
const BuyBox = ({ alternative_options, className, text }) => (jsxRuntimeExports.jsxs("div", { className: className, children: [jsxRuntimeExports.jsx("span", { className: `${namespace$8}__headline`, children: text }), alternative_options?.map((alternativeOption) => (createElement(AlternativeOption, { ...alternativeOption, key: alternativeOption.url })))] }));

const ThresholdLabel = ({ className, styles, text, values }) => {
    const { thousandSeparator, decimalSeparator } = usePolycardContext();
    if (!thousandSeparator || !decimalSeparator) {
        console.error(MsgThousandDecimalError);
        return null;
    }
    return (jsxRuntimeExports.jsx(Phrase, { className: className, styles: styles, text: text, values: values, thousandSeparator: thousandSeparator, decimalSeparator: decimalSeparator }));
};

const InstallmentsPrice = ({ no_interest, text, className, styles, values, }) => {
    const { thousandSeparator, decimalSeparator } = usePolycardContext();
    const styleProps = {
        color: no_interest ? 'positive' : 'primary',
        ...styles,
    };
    if (!thousandSeparator || !decimalSeparator) {
        // eslint-disable-next-line no-console
        console.error(MsgThousandDecimalError);
        return null;
    }
    return (jsxRuntimeExports.jsx(Phrase, { text: text, thousandSeparator: thousandSeparator, decimalSeparator: decimalSeparator, styles: styleProps, values: values, className: className }));
};

const namespace$7 = `${cardNamespace}-installments__options`;
const InstallmentsOptions = ({ installments_options, className, }) => (jsxRuntimeExports.jsx("div", { className: className, children: installments_options?.map((props) => (createElement(InstallmentsPrice, { className: namespace$7, ...props, key: props.text }))) }));

const Pill = ({ children, className: namespace, ...props }) => {
    const { thousandSeparator, decimalSeparator } = usePolycardContext();
    return (jsxRuntimeExports.jsxs("div", { className: `${namespace}__wrapper`, children: [jsxRuntimeExports.jsx(Phrase, { ...props, className: `${namespace}__pill`, decimalSeparator: decimalSeparator, iconClassName: `${namespace}__icon`, thousandSeparator: thousandSeparator }), children] }));
};

const Pills = ({ pills, type, className }) => {
    const namespace = `${cardNamespace}-${type}`;
    return (jsxRuntimeExports.jsx("div", { className: className, children: pills?.map((pill) => {
            const { discount, discount_time } = pill;
            const finalPillprops = discount ? { ...discount } : { ...pill };
            return (createElement(Pill, { ...finalPillprops, className: namespace, key: finalPillprops.text?.toLowerCase().replace(' ', '-') }, discount_time && jsxRuntimeExports.jsx(BlockText, { ...discount_time, className: `${namespace}__label` })));
        }) }));
};

const mapDecimalSymbol = {
    ',': 'comma',
    '.': 'dot',
};
const getFormattedIntFraction = (price, separator) => {
    const rawFraction = Math.floor(price).toString();
    return rawFraction.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, (n) => `${n}${separator}`);
};
const getFormattedDecimalFraction = (price, decimal_style) => {
    const fixedStr = price.toFixed(2);
    const decimalPart = fixedStr.split('.')[1];
    if (decimalPart !== '00' && decimal_style !== 'none') {
        return decimalPart;
    }
    return '';
};
const getAmount = (value, decimal_style, thousandSeparator) => {
    const fraction = getFormattedIntFraction(value, thousandSeparator);
    const cents = getFormattedDecimalFraction(value, decimal_style || 'superscript');
    return { fraction, cents };
};
const getCentsType = (decimal_style, decimalSeparator) => {
    if (decimal_style === 'superscript') {
        return 'superscript';
    }
    return mapDecimalSymbol[decimalSeparator];
};

const CurrentPrice = ({ value, size, currency, decimal_style = 'superscript', suffix, symbol, combo, }) => {
    const { thousandSeparator, decimalSeparator, isMobile, card_size } = usePolycardContext();
    const fontSize = useMemo(() => {
        const fontSizeMap = {
            small: 16,
            medium: 16,
            mobile: 20,
            large: 24,
        };
        if (size)
            return size;
        if (card_size !== 'large')
            return fontSizeMap[card_size];
        return isMobile ? fontSizeMap['mobile'] : fontSizeMap['large'];
    }, [size, card_size, isMobile]);
    if (!thousandSeparator || !decimalSeparator || !value || !currency) {
        // eslint-disable-next-line no-console
        console.error(MsgThousandDecimalError);
        return null;
    }
    const amount = getAmount(value, decimal_style, thousandSeparator);
    const centsType = getCentsType(decimal_style, decimalSeparator);
    return (jsxRuntimeExports.jsx(MoneyAmount, { size: fontSize, currencyId: currency, value: amount, centsType: centsType, suffix: suffix, symbol: symbol, combo: combo }));
};

const DiscountPrice = ({ size, value, className }) => {
    const { isMobile, card_size } = usePolycardContext();
    const fontSize = useMemo(() => {
        const fontSizeMap = {
            small: 10,
            medium: 12,
            mobile: 12,
            large: 14,
        };
        if (size)
            return size;
        if (card_size !== 'large')
            return fontSizeMap[card_size];
        return isMobile ? fontSizeMap['mobile'] : fontSizeMap['large'];
    }, [size, card_size, isMobile]);
    return jsxRuntimeExports.jsx(MoneyAmountDiscount, { className: className, size: fontSize, value: value });
};

const PreviousPrice = ({ value, size, currency, decimal_style = 'superscript', suffix, symbol, }) => {
    const { thousandSeparator, decimalSeparator } = usePolycardContext();
    if (!thousandSeparator || !decimalSeparator) {
        // eslint-disable-next-line no-console
        console.error(MsgThousandDecimalError);
        return null;
    }
    const amount = getAmount(value, decimal_style, thousandSeparator);
    const centsType = getCentsType(decimal_style, decimalSeparator);
    return (jsxRuntimeExports.jsx(MoneyAmount, { size: size ?? 12, currencyId: currency, value: amount, centsType: centsType, suffix: suffix, symbol: symbol, previous: true }));
};

const namespace$6 = `${cardNamespace}-price`;
const Price = ({ price_to_agree, discount, discount_label, current_price, previous_price, installments, price_detail, prefix, className, }) => (jsxRuntimeExports.jsxs("div", { className: className, children: [price_to_agree ? (jsxRuntimeExports.jsx(BlockText, { ...price_to_agree, className: classnames(`${namespace$6}__agree`) })) : null, prefix ? jsxRuntimeExports.jsx(BlockText, { ...prefix, className: classnames(`${namespace$6}__prefix`) }) : null, previous_price ? jsxRuntimeExports.jsx(PreviousPrice, { ...previous_price }) : null, current_price ? (jsxRuntimeExports.jsxs("div", { className: classnames(`${namespace$6}__current`), children: [jsxRuntimeExports.jsx(CurrentPrice, { ...current_price, combo: !!previous_price }), discount_label ? (jsxRuntimeExports.jsx(BlockText, { ...discount_label, className: classnames('andes-money-amount__discount', `${namespace$6}__disc_label`) })) : null, discount ? jsxRuntimeExports.jsx(DiscountPrice, { ...discount }) : null] })) : null, price_detail ? (jsxRuntimeExports.jsx(BlockText, { ...price_detail, className: classnames(`${namespace$6}__price-detail`) })) : null, installments ? (jsxRuntimeExports.jsx(InstallmentsPrice, { ...installments, className: classnames(`${namespace$6}__installments`) })) : null] }));

const Icons = ['icon_star', 'icon_star_half', 'icon_star_fill'];

const getNumTotal = (total) => Math.abs(Math.trunc(typeof total === 'number' ? total : 0));
const getTextIconByMapper = (index) => `{${Icons[index]}}`;
const fractionalPart = (rating) => Math.floor(10 * rating - 10 * Math.floor(rating)) / 10; // cause numerical errors by divider number almost equals
const getTruncAndRound = (rating) => [Math.floor, fractionalPart].map((item) => item(rating));
const getValueIconByMapper = (index) => {
    const isAriaHidden = true;
    const type = 'icon';
    const preKey = index === 1 ? '_half' : '';
    const key = `icon_star${index === 2 ? '_fill' : preKey}`;
    const icon = { key: `star${index === 2 ? '_fill' : preKey}`, aria_hidden: isAriaHidden };
    return { type, key, icon };
};
const validRating = (rating) => {
    if (typeof rating !== 'number')
        return 0;
    const validRatingValue = Math.min(5, Math.max(0, Number(rating)));
    return validRatingValue;
};
const getMapperArray = (rating) => {
    const [truncated, fractional] = getTruncAndRound(rating);
    return Array.from({ length: 5 }, (_, index) => {
        if (index < truncated)
            return 2;
        if (index === truncated) {
            if (fractional <= 0.2)
                return 0;
            return fractional > 0.7 ? 2 : 1;
        }
        return 0;
    });
};
const getTextValues = (rating_average) => {
    const ratings = [0, 1, 2];
    const rating = validRating(rating_average);
    const mapperArray = getMapperArray(rating);
    const text = mapperArray.map((item) => getTextIconByMapper(item)).join(' ');
    const value = ratings
        .filter((item) => mapperArray.some((el) => item === el))
        .map((item) => getValueIconByMapper(item));
    return [text, value];
};
const getRatingAverage = (rating_average) => {
    const rating = validRating(rating_average);
    return rating % 1 === 0 ? `${rating}.0` : `${rating}`;
};

const namespace$5 = `${cardNamespace}-reviews`;
const MemoizedPhrase = React.memo(Phrase);
const Reviews = ({ className, rating_average, total, alt_text }) => {
    const [text, values] = useMemo(() => getTextValues(rating_average), [rating_average]);
    const num_total = getNumTotal(total);
    const ratingAverage = getRatingAverage(rating_average);
    return (jsxRuntimeExports.jsxs("div", { className: className, children: [jsxRuntimeExports.jsx("span", { className: "andes-visually-hidden", children: alt_text }), jsxRuntimeExports.jsx("span", { className: classnames(`${namespace$5}__rating`), "aria-hidden": "true", children: ratingAverage }), jsxRuntimeExports.jsx(MemoizedPhrase, { text, values, className: classnames(`${namespace$5}__starts`) }, rating_average), jsxRuntimeExports.jsx("span", { className: classnames(`${namespace$5}__total`), "aria-hidden": "true", children: `(${num_total})` })] }));
};

const namespace$4 = `${cardNamespace}-shipping`;
const Shipping = ({ text, styles, values, className, promise_type = 'none', icon, alt_text, additional_text, }) => {
    const isPromise = promise_type && promise_type !== 'none';
    const shippingClases = classnames({
        [`${namespace$4}--${promise_type}`]: isPromise,
    });
    const iconClasses = classnames({
        [`${namespace$4}__promise-icon--meli-plus`]: icon?.key.includes('plus'),
        [`${namespace$4}__promise-icon--full-super`]: icon?.key.includes('super'),
        [`${namespace$4}__promise-icon--full`]: !icon?.key.includes('plus') && !icon?.key.includes('super'),
    });
    const iconValues = icon
        ? [
            {
                ...(!!icon && {
                    key: icon.key,
                    type: 'icon',
                    icon: { aria_label: icon?.alt_text, key: icon?.key, src: icon?.src },
                }),
            },
        ]
        : [];
    const phrase = () => (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [text && (jsxRuntimeExports.jsx(Phrase, { text: text, values: values, styles: styles, className: shippingClases || undefined, aria_label: alt_text || undefined, isAsText: isPromise || !!icon })), icon && (jsxRuntimeExports.jsx(Phrase, { text: `{${icon.key}}`, values: iconValues, iconClassName: iconClasses, isAsText: false })), additional_text && (jsxRuntimeExports.jsx(Phrase, { text: additional_text, className: `${namespace$4}__additional_text` }))] }));
    return (jsxRuntimeExports.jsx("div", { className: className, ...(alt_text && { 'aria-label': alt_text }), children: phrase() }));
};

const Title = ({ title_tag, long_title, className, values, styles, text, }) => {
    const { targetLink, target } = usePolycardContext();
    const { url, onClick } = useCardContext();
    const resolvedTarget = target ?? targetLink;
    const titleClassName = classnames(className, {
        [`${className}--long`]: long_title,
    });
    return (jsxRuntimeExports.jsx(Phrase, { text: text, url: url, styles: styles, values: values, className: titleClassName, target: url ? resolvedTarget : undefined, onClick: onClick, asBox: title_tag, boxClassName: title_tag ? `${className}-wrapper` : undefined, ...(!url && !title_tag && { asText: 'p' }) }));
};

const VariationItem = ({ pictures, picture_size, variation_id, description, url_product, url_params: variationParams, url_fragments, sanitized_title, }) => {
    const namespace = 'poly-variations__item';
    const { isNavigableToVariation, url_prefix, url_params_default, url_fragments_default } = usePolycardContext();
    const { setPicturesSelected, variationSelected, setVariationSelected, pickerAction, metadata } = useCardContext();
    const urlVariations = getUrl(metadata, variationParams, url_prefix, url_params_default, url_fragments_default, url_fragments, url_product);
    const handleVariationSelect = useCallback(() => {
        if (setPicturesSelected && !pickerAction) {
            const updatedPictures = pictures.map((picture) => ({
                ...picture,
                lazyload: pictures.length === 1 ? false : picture?.lazyload,
            }));
            setPicturesSelected(updatedPictures);
        }
        if (pickerAction) {
            pickerAction(variation_id);
        }
        if (setVariationSelected) {
            setVariationSelected(variation_id);
        }
    }, [setPicturesSelected, pickerAction, pictures, variation_id, setVariationSelected]);
    const itemClasses = classnames(namespace, {
        [`${namespace}--active`]: variation_id === variationSelected,
    });
    return (jsxRuntimeExports.jsx("li", { className: itemClasses, children: jsxRuntimeExports.jsx("a", { ...(!isNavigableToVariation
                ? { onClick: handleVariationSelect }
                : { href: urlVariations }), role: "button", "aria-label": description, className: "poly-variations__anchor", children: !!pictures && (jsxRuntimeExports.jsx(Picture, { id: pictures[0].id, size: picture_size, alt: description, sanitized_title: sanitized_title })) }) }, `variation-item-${variation_id}`));
};

const VariationPicker = ({ text, variations, picture_size, total_variations, }) => {
    const namespace = 'poly-variations-picker';
    const item_namespace = 'poly-variations__item';
    const { isMobile, card_size } = usePolycardContext();
    const { setLabelPill, url } = useCardContext();
    // Calcular el ancho del ítem, el ancho de un item + margin es 52px en mobile, 46px en desktop, 48 para small y medium
    const itemWidth = useMemo(() => {
        const itemWidthMap = {
            small: 48,
            medium: 50,
            mobile: 52,
            large: 46,
        };
        const widthByCardSize = card_size !== 'large' ? itemWidthMap[card_size] : null;
        return widthByCardSize || (isMobile ? itemWidthMap['mobile'] : itemWidthMap['large']);
    }, [card_size, isMobile]);
    const contenedorRef = useRef(null);
    const [needExtraItem, setNeedExtraItem] = useState(false);
    const [variationsToRender, setVariationsToRender] = useState(0);
    const [variationsGroup, setvariationsGroup] = useState([]);
    useEffect(() => {
        if (contenedorRef.current) {
            const variationsInClientWidth = Math.floor((contenedorRef.current.clientWidth - 10) / itemWidth);
            const isSpaceEnough = !!total_variations && total_variations <= variationsInClientWidth;
            setVariationsToRender(isSpaceEnough ? variationsInClientWidth : variationsInClientWidth - 1);
            setNeedExtraItem(!isSpaceEnough);
        }
    }, [itemWidth, total_variations, contenedorRef]);
    useEffect(() => {
        const newVariationsGroup = (variations ?? [])
            .map(({ pictures, variation_id, description, url: url_product, url_params, url_fragments, sanitized_title, }, index) => {
            if (index > variationsToRender - 1) {
                return null;
            }
            const variationProps = {
                pictures,
                picture_size,
                variation_id,
                description,
                url_product,
                url_params,
                url_fragments,
                sanitized_title,
            };
            return createElement(VariationItem, { ...variationProps, key: `variation-picker-${variation_id}` });
        })
            .filter(Boolean);
        setvariationsGroup(newVariationsGroup);
    }, [needExtraItem, picture_size, variations, variationsToRender]);
    useEffect(() => {
        if (text && setLabelPill) {
            setLabelPill(text);
        }
    }, [text, setLabelPill]);
    return (variations && (jsxRuntimeExports.jsxs("ul", { className: namespace, ref: contenedorRef, children: [variationsGroup, variationsGroup && needExtraItem && (jsxRuntimeExports.jsx("li", { className: item_namespace, children: jsxRuntimeExports.jsx(Link, { url: url, classModified: "variations", children: `+${(total_variations ?? 0) - variationsGroup.length}` }) }, "variation-picker-extra"))] })));
};

const VariationSelect = ({ text, variations, picture_size, total_variations, }) => {
    const { setPicturesSelected, variationSelected, setVariationSelected, url, metadata } = useCardContext();
    const { isNavigableToVariation, url_prefix, url_params_default, url_fragments_default } = usePolycardContext();
    const namespace = 'poly-variations-select';
    const item_namespace = 'poly-variations__item';
    const wrapperVariation = isNavigableToVariation ? 'a' : React.Fragment;
    const WrapperTag = wrapperVariation;
    const maxVariations = 6;
    const hasMoreVariations = !!total_variations && total_variations > (variations?.length || 0);
    const [description, setDescription] = useState();
    useEffect(() => {
        if (variations) {
            setDescription(variations.find(({ variation_id: id }) => id === variationSelected)?.description);
        }
    }, [variations, variationSelected]);
    const variationUrls = (variations ?? []).map(({ variation_id, url_params: variationParams, url_fragments, url: url_product }) => ({
        variation_id,
        url: getUrl(metadata, variationParams, url_prefix, url_params_default, url_fragments_default, url_fragments, url_product),
    }));
    const handleVariationSelect = (variationId) => {
        const variation = variations?.find(({ variation_id: id }) => id === variationId);
        if (variation) {
            if (setPicturesSelected) {
                setPicturesSelected(variation.pictures.map((picture) => ({
                    ...picture,
                    lazyload: variation.pictures.length === 1 ? false : picture?.lazyload,
                })));
            }
            if (setVariationSelected) {
                setVariationSelected(variation.variation_id);
            }
        }
    };
    const dropDownOptions = () => {
        const options = (variations ?? []).map(({ variation_id, pictures, description: itemDescription, sanitized_title, }, index) => {
            const urlVariation = variationUrls.find(({ variation_id: id }) => id === variation_id)?.url;
            if (hasMoreVariations &&
                index + 1 >= maxVariations &&
                index === (variations?.length ?? 0) - 1) {
                return null;
            }
            return (jsxRuntimeExports.jsx(ListItem, { value: variation_id, className: classnames(item_namespace), "aria-label": itemDescription, children: !!pictures && (jsxRuntimeExports.jsx(WrapperTag, { ...(isNavigableToVariation && {
                        href: urlVariation,
                        className: 'poly-variations__anchor',
                    }), children: jsxRuntimeExports.jsx(Picture, { id: pictures[0].id, size: picture_size, alt: itemDescription, sanitized_title: sanitized_title }) })) }, `variation-select-${variation_id}`));
        });
        if (hasMoreVariations && options) {
            const extraItemLable = `+${total_variations - options.filter(Boolean).length}`;
            options.push(jsxRuntimeExports.jsx(ListItem, { className: "poly-variations__item", "aria-label": extraItemLable, children: jsxRuntimeExports.jsx(Link, { url: url, classModified: "variations", children: extraItemLable }) }, "variation-select-extra"));
        }
        return options.filter(Boolean);
    };
    return (description && (jsxRuntimeExports.jsxs("div", { className: `${namespace}`, children: [jsxRuntimeExports.jsx("p", { className: `${namespace}__label`, children: `${text}:` }), jsxRuntimeExports.jsx(DropdownStandalone, { className: `${namespace}__dropdown`, label: description, value: variationSelected, menuAlignment: "bottom", onChange: (e, variationId) => typeof variationId === 'string' &&
                    !isNavigableToVariation &&
                    handleVariationSelect(variationId), children: dropDownOptions() })] })));
};

const Variations = ({ className, text, variations, picture_size, total_variations, }) => {
    const { type, isMobile, card_size } = usePolycardContext();
    const { setVariationSelected } = useCardContext();
    const props = {
        variations,
        text,
        picture_size,
        total_variations,
    };
    useEffect(() => {
        if (setVariationSelected && variations?.length) {
            setVariationSelected(variations[0].variation_id);
        }
    }, [setVariationSelected, variations]);
    return (jsxRuntimeExports.jsx("div", { className: className, children: type?.includes('list') && !isMobile && card_size === 'large' ? (jsxRuntimeExports.jsx(VariationSelect, { ...props })) : (jsxRuntimeExports.jsx(VariationPicker, { ...props })) }));
};

// Definimos una constante que es un objeto que asigna cada tipo de componente (ComponentType) a una clave de propiedad correspondiente en un arreglo de objetos (ComponentInterface[]).
// Ejemplo con esto podemos acceder a la propiedad 'shipping' de un componente de tipo 'shipping' de la siguiente manera: componentTypeToPropKey['shipping']
const componentTypeToPropKey = {
    action_links: 'action_links',
    add_to_cart: 'add_to_cart',
    attributes_list: 'attributes_list',
    attributes_selected: 'attributes_selected',
    available_units: 'available_units',
    brand: 'brand',
    buy_box: 'buy_box',
    cbt: 'cbt',
    compats: 'compats',
    coupons: 'coupons',
    cpg: 'cpg',
    threshold_label: 'threshold_label',
    headline: 'headline',
    highlight: 'highlight',
    installation_services: 'installation_services',
    installments_options: 'installments_options',
    item_condition: 'item_condition',
    label: 'label',
    last_available: 'last_available',
    location: 'location',
    manufacturing_time: 'manufacturing_time',
    meli_coin: 'meli_coin',
    paused: 'paused',
    pill: 'pill',
    possession_date: 'possession_date',
    price_per_quantity: 'price_per_quantity',
    price: 'price',
    promotions: 'promotions',
    purchase_options: 'purchase_options',
    rebates: 'rebates',
    reviews: 'reviews',
    seller: 'seller',
    shipped_from: 'shipped_from',
    shipping: 'shipping',
    title: 'title',
    trade_in: 'trade_in',
    variations_text: 'variations_text',
    variations: 'variations',
    visit_history: 'visit_history',
    visit_request: 'visit_request',
    // aca van los nuevos nombres de componentes como se esperan en el contrato
};
// Esta constante es un objeto que asigna cada tipo de componente (ComponentType) a un componente de React espesifico como title : <Title>
// Estamos utilizando as FC<ComponentProps<ComponentType>> para asegurarnos de que Title coincida con el tipado esperado de FC<ComponentProps<ComponentType>> que sera TitleProps
const ComponentsList = {
    action_links: ActionLinks,
    add_to_cart: AddToCart,
    attributes_list: AttributesList,
    available_units: BlockText,
    brand: BlockText,
    buy_box: BuyBox,
    cbt: BlockText,
    cpg: BlockText,
    compats: BlockText,
    threshold_label: ThresholdLabel,
    installation_services: BlockText,
    coupons: Pills,
    shipped_from: BlockText,
    headline: BlockText,
    highlight: BlockText,
    installments_options: InstallmentsOptions,
    item_condition: BlockText,
    label: BlockText,
    last_available: BlockText,
    location: BlockText,
    manufacturing_time: BlockText,
    meli_coin: Pills,
    paused: BlockText,
    pill: Pills,
    possession_date: BlockText,
    price_per_quantity: Pills,
    price: Price,
    promotions: Pills,
    purchase_options: BlockText,
    rebates: Pills,
    reviews: Reviews,
    seller: BlockText,
    shipping: Shipping,
    title: Title,
    trade_in: BlockText,
    variations_text: BlockText,
    variations: Variations,
    attributes_selected: AttributesList,
    visit_history: BlockText,
    visit_request: BlockText,
    // aca van los nuevos <Componentes> as FC<ComponentProps<ComponentType>>,
};

const namespace$3 = 'poly-component';
const ListComponents = ({ components }) => {
    const { metadata: { id }, } = useCardContext();
    if (components.length === 0)
        return null;
    const typeMapping = {
        coupon: 'coupons',
        rebate: 'rebates',
        pill: 'pill',
        label: 'label',
    };
    return (jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: components.map((component) => {
            const key = getKey(component, id);
            const { type, ...props } = component;
            const propKey = componentTypeToPropKey[type];
            if (propKey && propKey in props && 'type' in component) {
                // separa las promociones en componentes pills o labels individuales segun su type y renderiza cada componente
                // pill = type (coupon, rebate, pill, price_per_quantity, meli_coin )
                // lable = type label
                if (component.type === 'promotions') {
                    return component.promotions?.map(({ type: promotionType, ...promotionProps }) => {
                        let PromotionComponent = ComponentsList['pill'];
                        let promotionComponentProps = {};
                        if (['coupon', 'rebate', 'pill'].includes(promotionType)) {
                            promotionComponentProps = {
                                pills: [promotionProps],
                                type: typeMapping[promotionType],
                            };
                        }
                        else if (['label'].includes(promotionType)) {
                            PromotionComponent = ComponentsList['label'];
                            promotionComponentProps = { ...promotionProps };
                        }
                        return (jsxRuntimeExports.jsx(PromotionComponent, { ...promotionComponentProps, className: `${namespace$3}__${typeMapping[promotionType].replace(/_/g, '-')}` }, key + promotionType));
                    });
                }
                // Obtenemos el componente correspondiente según el tipo
                const Component = ComponentsList[type];
                // Obtenemos los props del componente según el propKey
                const componentProps = props[propKey];
                // Inicializamos componentPropsToPass con los props del componente, esto con el fin de poder modificar componentPropsToPass en caso de ser necesario (lo es en los arreglos)
                let componentPropsToPass = { ...componentProps, type };
                // Verificamos si se necesita modificar componentPropsToPass, para los casos donde se esperan arreglos y no objetos
                if (component.type === 'action_links' || component.type === 'installments_options') {
                    componentPropsToPass = {
                        [component.type]: componentProps,
                    };
                }
                // convertimos en arreglo los compoentes que comparten pill
                if (component.type === 'coupons' ||
                    component.type === 'rebates' ||
                    component.type === 'pill' ||
                    component.type === 'price_per_quantity' ||
                    component.type === 'meli_coin') {
                    const pillsprops = {
                        pills: Array.isArray(componentProps) ? componentProps : [componentProps],
                        type: component.type,
                    };
                    componentPropsToPass = pillsprops;
                }
                const componentClassName = classnames(`${namespace$3}__${component.type.replace(/_/g, '-')}`, {
                    [componentPropsToPass?.class_name]: Object.prototype.hasOwnProperty.call(componentPropsToPass, 'class_name'),
                });
                return jsxRuntimeExports.jsx(Component, { ...componentPropsToPass, className: componentClassName }, key);
            }
            // Si propKey no es una propiedad válida, devolvemos null
            return null;
        }) }));
};

const namespace$2 = `${cardNamespace}-component__badge`;
const Badge = ({ src, className, alt_text, values, text }) => {
    const { url } = useCardContext();
    const Component = src ? Picture : Phrase;
    const badgeClasess = classnames(className, namespace$2, {
        [`${namespace$2}--image`]: !!src,
    });
    return (jsxRuntimeExports.jsx(Link, { className: badgeClasess, url: url, children: jsxRuntimeExports.jsx(Component, { ...(src ? { id: 'badge', src, alt: alt_text } : { text, isAsText: false, values }) }) }));
};

const namespace$1 = `${cardNamespace}-component__float-highlight`;
const FloatHighlight = ({ className, styles, text, values }) => {
    const { url } = useCardContext();
    const handleClick = () => {
        if (url) {
            window.location.href = url;
        }
    };
    const floatHighlightClassName = classnames(namespace$1, {
        [`${className}`]: className,
    });
    return (jsxRuntimeExports.jsx(Phrase, { className: floatHighlightClassName, styles: styles, text: text, values: values, onClick: handleClick }));
};

const namespace = `${cardNamespace}-card`;
const Card = ({ as, bookmarkAction, addToCartActions, cardNumber, checkbox: checkboxComponent, className, onClick, onMouseEnter, onMouseLeave, pickerAction, polycard, styles, useLazyImage, suggestions, onAfterImageChange, }) => {
    const { debug_info, type, isMobile, isTablet, checkbox, card_size, deviceType, action_links, url_prefix, url_params_default, url_fragments_default, isNavigableToVariation, allowHover = true, } = usePolycardContext();
    const { metadata, bookmark, featured, ads_promotions, tour_virtual, seller_logo, pictures, unique_id, float_highlight, badge, } = polycard;
    const { vertical_id, image_ratio, image_square } = metadata;
    const { isGrid, isSingle, isList, isTwoCols, isListHeight, isGridHeight, isCarousel, isDesktop, squareMobile, Imagewrapper, shouldDisplayLabelPill, } = useEvaluationsCard({
        type,
        isMobile,
        isTablet,
        deviceType,
        image_ratio,
        pictures,
        image_square,
        vertical_id,
        card_size,
    });
    const [isHover, setIsHover] = useState(false);
    const [needSuggestions, setNeedSuggestions] = useState(false);
    const [labelPill, setLabelPill] = useState(null);
    const [variationSelected, setVariationSelected] = useState();
    const [debugToolModule, setDebugToolModule] = useState(null);
    const [colProps, col1Props, col2Props] = getColProps(isTwoCols, polycard.components);
    const badgeProps = seller_logo || badge;
    const hasActionLinksComponent = polycard.components.some(({ type: typeComponent }) => typeComponent === 'action_links');
    const variationsComponent = polycard.components.find(({ type: typeComponent }) => typeComponent === 'variations');
    const titleText = polycard.components.find(({ type: typeComponent }) => typeComponent === 'title')
        ?.title?.text;
    const [picturesSelected, setPicturesSelected] = useState(pictures?.pictures ?? []);
    const filteredVariations = isNavigableToVariation
        ? undefined
        : variationsComponent?.variations?.variations.find(({ variation_id }) => variation_id === variationSelected);
    const variationParams = filteredVariations?.url_params;
    const variationsFragments = filteredVariations?.url_fragments;
    const cardUrl = getUrl(metadata, variationParams, url_prefix, url_params_default, url_fragments_default, variationsFragments);
    useEffect(() => {
        if (pictures?.pictures)
            setPicturesSelected(pictures?.pictures);
    }, [pictures?.pictures]);
    const handlerOnmouseEnter = () => {
        if (allowHover) {
            setIsHover(true);
        }
        if (onMouseEnter) {
            onMouseEnter();
        }
    };
    const handlerOnmouseLeave = () => {
        if (allowHover) {
            setIsHover(false);
        }
        if (onMouseLeave) {
            onMouseLeave();
        }
    };
    const mainClassName = classnames(className, `${namespace}`, `${namespace}--${type === 'list-multicolumn' ? 'list' : type}`, {
        [`${namespace}--${card_size}`]: card_size,
        [`${namespace}--mobile`]: card_size === `large` && isMobile,
        [`${namespace}--tablet`]: card_size === `large` && isTablet,
        [`${namespace}--hover`]: isHover,
        [`${namespace}--checkbox`]: !!checkbox &&
            !!checkboxComponent &&
            !isMobile &&
            (type === 'list' || type === 'list-multicolumn'),
        [`${namespace}--${vertical_id}`]: vertical_id,
    });
    useEffect(() => {
        if (debug_info) {
            import('./debug-tool-CxKc4QqH.esm.js')
                .then((module) => {
                setDebugToolModule(module);
            })
                .catch((error) => {
                // eslint-disable-next-line no-console
                console.error('Error al importar la librería:', error);
            });
        }
    }, [debug_info]);
    return (jsxRuntimeExports.jsxs(CardContext, { contextValue: {
            addToCartActions,
            bookmark: { ...bookmark, bookmarkAction },
            cardNumber,
            checkbox: checkboxComponent,
            isHover,
            metadata,
            needSuggestions,
            onClick,
            pickerAction,
            picturesSelected,
            setLabelPill,
            setNeedSuggestions,
            setPicturesSelected,
            setVariationSelected,
            suggestions,
            title: titleText,
            url: cardUrl,
            useLazyImage,
            variationSelected,
            onAfterImageChange,
        }, children: [jsxRuntimeExports.jsxs(Layout, { className: mainClassName, styles: styles, as: as, ...(isDesktop && { onMouseEnter: handlerOnmouseEnter }), ...(isDesktop && { onMouseLeave: handlerOnmouseLeave }), children: [jsxRuntimeExports.jsxs("div", { className: classnames(`${namespace}__portada`, {
                            [`${namespace}__portada--no-line`]: !!variationSelected,
                            [`${namespace}__portada--list-height`]: isListHeight && !isCarousel,
                            [`${namespace}__portada--grid-height`]: isGridHeight,
                        }), children: [!!polycard && !!polycard.pictures && !!picturesSelected && (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [float_highlight && jsxRuntimeExports.jsx(FloatHighlight, { ...float_highlight }), jsxRuntimeExports.jsx(ImagesContainer, { alt_text: polycard.pictures.alt_text, Imagewrapper: Imagewrapper, isCarousel: isCarousel, isListHeight: isListHeight, overlay: polycard.pictures?.overlay, pictures: picturesSelected, sanitized_title: polycard.pictures?.sanitized_title, size: polycard.pictures.size, square: squareMobile || polycard?.pictures?.square })] })), !isHover && labelPill && shouldDisplayLabelPill && !isTablet && (jsxRuntimeExports.jsx("span", { className: classnames(`${namespace}__label-pill`), children: labelPill })), badgeProps && jsxRuntimeExports.jsx(Badge, { ...badgeProps })] }), debugToolModule && debug_info && jsxRuntimeExports.jsx(debugToolModule.DebugTool, { polycard: polycard }), jsxRuntimeExports.jsxs("div", { className: `${namespace}__content`, children: [jsxRuntimeExports.jsx(ListComponents, { ...colProps }), col1Props.components && col1Props.components?.length > 0 && (jsxRuntimeExports.jsxs("div", { className: "poly-content", children: [jsxRuntimeExports.jsx("div", { className: classnames('poly-content__column'), children: jsxRuntimeExports.jsx(ListComponents, { ...col1Props }) }), jsxRuntimeExports.jsx("div", { className: classnames('poly-content__column'), children: jsxRuntimeExports.jsx(ListComponents, { ...col2Props }) })] })), !hasActionLinksComponent && action_links && action_links.length > 0 && (jsxRuntimeExports.jsx(ActionLinks, { className: "poly-component__action-links", action_links: action_links }, "action_links")), isList && (ads_promotions || featured || tour_virtual) && (jsxRuntimeExports.jsxs("div", { className: `${cardNamespace}-footer`, children: [tour_virtual && (createElement(BlockText, { ...tour_virtual, key: tour_virtual && 'tour_virtual', className: classnames({
                                            'poly-component__tour-virtual': !!tour_virtual,
                                        }), text: tour_virtual?.text || '' })), (featured || ads_promotions) && (createElement(BlockText, { ...(ads_promotions || featured), key: (ads_promotions && 'ads_promotions') || (featured && 'featured'), className: classnames({
                                            'poly-component__ads-promotions': !!ads_promotions,
                                            'poly-component__featured': !!featured,
                                        }), text: ads_promotions?.text || featured?.text || '' }))] }))] }), (isGrid || isSingle) && (ads_promotions || featured || tour_virtual) && (jsxRuntimeExports.jsxs("div", { className: `${namespace}__footer`, children: [tour_virtual && (createElement(BlockText, { ...tour_virtual, key: tour_virtual && 'tour_virtual', className: classnames({
                                    'poly-component__tour-virtual': !!tour_virtual,
                                }), text: tour_virtual?.text || '' })), (ads_promotions || featured) && (createElement(BlockText, { ...(ads_promotions || featured), key: (ads_promotions && 'ads_promotions') || (featured && 'featured'), className: classnames({
                                    'poly-component__ads-promotions': !!ads_promotions,
                                    'poly-component__featured': !!featured,
                                }), text: ads_promotions?.text || featured?.text || '' }))] })), bookmarkAction && bookmark && jsxRuntimeExports.jsx(Bookmark, {})] }, unique_id), isList && jsxRuntimeExports.jsx(Suggestions, {})] }));
};

export { Card as C, Devices as D, PolycardContext as P, useCardContext as a, measuringFlag as b, cardNamespace as c, PictureSizes as d, PictureSquares as e, jsxRuntimeExports as j, measuringHeight as m, usePolycardContext as u };
